(function () {
  const cfg = window.ORDERTEAM || {};
  const apiBase = String(cfg.apiBase || '').replace(/\/$/, '');
  const passwordRequired = Boolean(cfg.passwordRequired);
  const storageKey = cfg.storageKey || 'ot_pass_v1';
  const DEFAULT_STATUS_URL =
    'https://script.google.com/macros/s/AKfycbxA9oVVJVPiivYYhRnLdpov15DsE3DKl8FNoBqUPCXCNAI5cW4Pg7kV2dzjk1xUVcYC/exec';
  const googleStatusUrl = String(cfg.statusUrl || DEFAULT_STATUS_URL).trim();
  const app = document.getElementById('app') || document.getElementById('orderteam-app');
  if (!app) return;

  const STEPS = [
    { id: 'printing', label: 'Baskıda' },
    { id: 'print', label: 'Baskı Tamam' },
    { id: 'ready', label: 'Ürün Hazır' },
    { id: 'packed', label: 'Paketlendi' },
    { id: 'shipped', label: 'Gönderildi' },
  ];
  const STEP_ORDER = { '': 0, printing: 1, print: 2, ready: 3, packed: 4, shipped: 5 };
  const FILTERS = [
    { id: '', label: 'Tümü' },
    { id: 'wait', label: 'İşlemsiz' },
    { id: 'printing', label: 'Baskıda' },
    { id: 'print', label: 'Baskı Tamam' },
    { id: 'ready', label: 'Hazır' },
    { id: 'packed', label: 'Paketlendi' },
    { id: 'shipped', label: 'Gönderildi' },
  ];

  let lastData = { orders: [], updatedAt: '' };
  let filterStatus = '';
  let filterSource = '';
  let filterPayment = '';
  let searchQuery = '';
  let sortKey = 'time';
  let sortDir = 'desc';
  const sharedStatuses = {};
  const pendingStatuses = {};
  let lastStatusSig = '';
  let alertsArmed = false;
  const seenStatus = {};
  let audioCtx = null;
  let pullBusy = false;
  let pullSeq = 0;
  const statusChannel =
    typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('orderteam-status') : null;

  const money = (n, c) => {
    const num = Number(n || 0);
    return (
      new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num) +
      ' ' +
      (c === 'TRY' || !c ? '₺' : c)
    );
  };

  const fmtDate = (iso) => {
    try {
      return new Date(iso).toLocaleString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return iso || '';
    }
  };

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getPass() {
    try {
      return localStorage.getItem(storageKey) || sessionStorage.getItem(storageKey) || '';
    } catch {
      try {
        return sessionStorage.getItem(storageKey) || '';
      } catch {
        return '';
      }
    }
  }

  function setPass(v) {
    try {
      localStorage.setItem(storageKey, v);
    } catch {
      /* gizli mod */
    }
    try {
      sessionStorage.setItem(storageKey, v);
    } catch {
      /* */
    }
  }

  function clearPass() {
    try {
      localStorage.removeItem(storageKey);
    } catch {
      /* */
    }
    try {
      sessionStorage.removeItem(storageKey);
    } catch {
      /* */
    }
  }

  const CLEAR_STATUS = 'clear';
  const PRINTING_EXPIRE_MS = 12 * 60 * 60 * 1000;
  /** Baskıda 12s dolunca sadece bildirim — işlemsize otomatik alınmaz */
  const printingExpireNotified = new Map();

  function normalizeTeamStatus(raw) {
    const v = String(raw || '').trim();
    if (!v || v === CLEAR_STATUS || v === 'wait' || v === 'none' || v === 'işlemsiz') return '';
    return v;
  }

  function statusEntry(raw) {
    if (!raw) return null;
    if (typeof raw === 'string') {
      return { status: normalizeTeamStatus(raw), at: 0 };
    }
    if (raw.cleared) return { status: '', at: Number(raw.at) || 0 };
    if (raw.status != null && raw.status !== undefined) {
      return { status: normalizeTeamStatus(raw.status), at: Number(raw.at) || 0 };
    }
    return null;
  }

  function mergeStatusInto(target, key, entry, { toast = false } = {}) {
    if (!key || !entry) return false;
    const cur = target[key];
    if (cur && Number(cur.at || 0) > Number(entry.at || 0)) return false;
    const nextStatus = normalizeTeamStatus(entry.status);
    const nextAt = Number(entry.at) || 0;
    if (!nextStatus) {
      const changed = Boolean(cur && normalizeTeamStatus(cur.status));
      // Tombstone: boş durum + at — eski feed/poll geri yazmasın
      target[key] = { status: '', at: nextAt };
      if (toast && changed) noteStatus(key, '');
      return true;
    }
    const changed = !cur || normalizeTeamStatus(cur.status) !== nextStatus;
    target[key] = { status: nextStatus, at: nextAt };
    if (toast && changed) noteStatus(key, nextStatus);
    return true;
  }

  function ingestStatusMap(map) {
    if (!map || typeof map !== 'object') return false;
    let changed = false;
    Object.entries(map).forEach(([key, raw]) => {
      if (key === '__refresh') return;
      const hit = statusEntry(raw);
      if (!hit) return;
      const pend = pendingStatuses[key];
      if (pend) {
        const pendAt = Number(pend.at || 0);
        const hitAt = Number(hit.at || 0);
        // Bekleyen temizleme/yazma varken daha eski uzak durum uygulama
        if (pendAt > hitAt) return;
        const pendStatus = normalizeTeamStatus(pend.status);
        const hitStatus = normalizeTeamStatus(hit.status);
        if (pendStatus === hitStatus || (!pendStatus && !hitStatus)) {
          delete pendingStatuses[key];
        } else if (!pendStatus && hitStatus) {
          // Hâlâ dolu geliyor — clear onaylanmadı, pending kalsın
          return;
        } else {
          delete pendingStatuses[key];
        }
      }
      // Arka plan sync bildirimi basmasın (döngü/toast spam)
      if (mergeStatusInto(sharedStatuses, key, hit, { toast: false })) changed = true;
    });
    return changed;
  }

  function ingestFeedStatuses(orders) {
    (orders || []).forEach((o) => {
      if (!o || !o.orderName || !o.teamStatus) return;
      if (pendingStatuses[o.orderName]) return;
      const at = Number(o.teamStatusAt || 0);
      const cur = Math.max(
        Number(sharedStatuses[o.orderName]?.at || 0),
        Number(pendingStatuses[o.orderName]?.at || 0)
      );
      if (at < cur) return;
      if (at === cur && sharedStatuses[o.orderName]) return;
      ingestStatusMap({
        [o.orderName]: { status: o.teamStatus, at },
      });
    });
  }

  function resolvedEntry(order) {
    const name = order?.orderName;
    const pend = name ? pendingStatuses[name] : null;
    const shared = name ? sharedStatuses[name] : null;
    const feed = order?.teamStatus
      ? { status: order.teamStatus, at: Number(order.teamStatusAt || 0) }
      : null;
    const pick = [pend, shared, feed].filter(Boolean).sort((a, b) => (b.at || 0) - (a.at || 0))[0];
    if (!pick) return null;
    return pick;
  }

  function showPrintingExpireToast(orderName, customer) {
    const host = toastHost();
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'ot-toast is-printing ot-toast-expire';
    const who = customer ? `${orderName} · ${customer}` : orderName;
    card.innerHTML = `
      <strong>Baskıda 12 saat doldu</strong>
      <span class="ot-toast-order">Sipariş: ${esc(who)}</span>
      <span class="ot-toast-status">Durum değişmedi · sadece uyarı</span>
    `;
    card.onclick = () => card.remove();
    host.appendChild(card);
    while (host.children.length > 4) host.firstElementChild.remove();
    setTimeout(() => card.remove(), 12000);
  }

  function sweepExpiredPrinting() {
    const now = Date.now();
    const live = new Set();
    for (const o of lastData.orders || []) {
      if (!o?.orderName || isOrderShipped(o)) continue;
      const name = o.orderName;
      const pend = pendingStatuses[name];
      const shared = sharedStatuses[name];
      const feed = o.teamStatus
        ? { status: o.teamStatus, at: Number(o.teamStatusAt || 0) }
        : null;
      const pick = [pend, shared, feed].filter(Boolean).sort((a, b) => (b.at || 0) - (a.at || 0))[0];
      if (!pick) continue;
      if (normalizeTeamStatus(pick.status) !== 'printing') {
        printingExpireNotified.delete(name);
        continue;
      }
      const at = Number(pick.at || 0);
      if (!at || now - at < PRINTING_EXPIRE_MS) {
        if (printingExpireNotified.get(name) !== at) printingExpireNotified.delete(name);
        continue;
      }
      live.add(name);
      if (printingExpireNotified.get(name) === at) continue;
      printingExpireNotified.set(name, at);
      try {
        playStatusSound();
      } catch {
        /* */
      }
      showPrintingExpireToast(name, o.customer || '');
    }
    for (const key of [...printingExpireNotified.keys()]) {
      if (!live.has(key)) printingExpireNotified.delete(key);
    }
  }

  const VOICE_SUFFIX = '::__voice';
  const VOICE_YES = 'voice_yes';
  const VOICE_NO = 'voice_no';

  function voiceKey(name) {
    return String(name || '') + VOICE_SUFFIX;
  }

  function phoneDigits(value) {
    let digits = String(value || '').replace(/\D/g, '');
    if (digits.startsWith('90') && digits.length === 12) digits = digits.slice(2);
    if (digits.startsWith('0')) digits = digits.slice(1);
    return digits;
  }

  function applyCallMap(calls) {
    if (!calls || typeof calls !== 'object') return false;
    let changed = false;
    (lastData.orders || []).forEach((o) => {
      const phone = phoneDigits(o.phone);
      if (!phone || calls[phone] == null) return;
      const key = voiceKey(o.orderName);
      if (pendingStatuses[key]) return;
      const next = calls[phone] ? VOICE_YES : VOICE_NO;
      const cur = sharedStatuses[key];
      if (cur && cur.status === next) return;
      sharedStatuses[key] = { status: next, at: Number(cur?.at || 1) };
      changed = true;
    });
    return changed;
  }

  function isVoiceOk(orderName) {
    const e = pendingStatuses[voiceKey(orderName)] || sharedStatuses[voiceKey(orderName)];
    if (e) return e.status === VOICE_YES;
    const order = (lastData.orders || []).find((o) => o.orderName === orderName);
    return Boolean(order && order.voiceOk);
  }

  function phoneIcon() {
    return '<svg class="ot-phone-ic" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.6 10.8c1.4 2.7 3.9 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.5.6 3.8.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.6.6 3.8.1.4 0 .8-.3 1.1L6.6 10.8z"/></svg>';
  }

  function cargoIcon() {
    return '<svg class="ot-cargo-ic" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 6h12v9H3V6zm13 3h3.2L22 12.4V15h-6V9zM6.5 17.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"/></svg>';
  }

  function waMeHref(phone) {
    const digits = phoneDigits(phone);
    if (!digits) return '';
    return 'https://wa.me/90' + digits;
  }

  function nameMarks(order) {
    const note = String(order.note || '').trim();
    const cod = paymentKind(order) === 'cod';
    const parts = [];
    if (note) parts.push('<span class="ot-note-dot" title="Not var">!</span>');
    if (cod) {
      const on = isVoiceOk(order.orderName);
      parts.push(
        `<span class="ot-voice-dot ${on ? 'is-on' : 'is-off'}" title="${on ? 'Sesli onay alındı' : 'Sesli onay alınmadı'}">${phoneIcon()}</span>`
      );
      parts.push('<span class="ot-cargo-dot" title="Kapıda ödeme">' + cargoIcon() + '</span>');
    }
    return parts.join('');
  }

  function isOrderShipped(order) {
    if (order.shopifyShipped === true) return true;
    const s = String(order.fulfillment || '').toUpperCase();
    return s === 'FULFILLED' || s === 'SHIPPED';
  }

  function resolveStatus(order) {
    if (isOrderShipped(order)) return 'shipped';
    return normalizeTeamStatus((resolvedEntry(order) || {}).status || '');
  }

  function statusSignature(orders) {
    return (orders || lastData.orders || [])
      .map((o) => `${o.orderName}:${resolveStatus(o)}:${isVoiceOk(o.orderName) ? 1 : 0}`)
      .sort()
      .join('|');
  }

  function authParams() {
    return {
      password: getPass() || cfg.expectedPassword || '',
      secret: cfg.secret || 'shogun_excel_2026_91',
    };
  }

  function statusLabel(id) {
    const key = normalizeTeamStatus(id);
    if (!key) return 'İşlemsiz';
    return STEPS.find((s) => s.id === key)?.label || 'Bekliyor';
  }

  function armAlerts() {
    alertsArmed = true;
  }

  function orderByName(orderName) {
    return (lastData.orders || []).find((o) => o.orderName === orderName) || null;
  }

  function orderProductLine(orderName) {
    const order = orderByName(orderName);
    const titles = (order?.items || []).map((it) => String(it.title || '').trim()).filter(Boolean);
    if (!titles.length) return '';
    if (titles.length === 1) return titles[0];
    return `${titles[0]} +${titles.length - 1}`;
  }

  function productNeedLabel(item) {
    const title = String(item?.title || '').trim();
    const variant = String(item?.variant || '').trim();
    if (!title) return variant || 'Ürün';
    if (variant && variant.toLowerCase() !== title.toLowerCase()) return `${title} · ${variant}`;
    return title;
  }

  function unshippedProductNeeds(orders) {
    const map = new Map();
    for (const o of orders || []) {
      if (resolveStatus(o) === 'shipped') continue;
      for (const item of o.items || []) {
        const qty = Number(item.quantity || 0);
        if (!qty) continue;
        const label = productNeedLabel(item);
        const key = foldSearch(label);
        const cur = map.get(key);
        if (cur) cur.qty += qty;
        else map.set(key, { label, qty });
      }
    }
    return [...map.values()].sort(
      (a, b) => b.qty - a.qty || a.label.localeCompare(b.label, 'tr')
    );
  }

  function openProductNeeds() {
    const prev = document.querySelector('.ot-products-modal');
    if (prev) prev.remove();
    const rows = unshippedProductNeeds(lastData.orders || []);
    const totalQty = rows.reduce((n, r) => n + r.qty, 0);
    const box = document.createElement('div');
    box.className = 'ot-confirm ot-products-modal';
    const list = rows.length
      ? rows
          .map(
            (r) =>
              `<li><span class="ot-need-name">${esc(r.label)}</span><span class="ot-need-qty">${esc(String(r.qty))} adet</span></li>`
          )
          .join('')
      : '<li class="ot-need-empty">Gönderilmeyen ürün yok</li>';
    box.innerHTML = `
      <div class="ot-confirm-card ot-products-card" role="dialog" aria-modal="true">
        <p>Sipariş Ürünler</p>
        <p class="ot-confirm-sub">Gönderilmeyen siparişler · ${rows.length} çeşit · ${totalQty} adet</p>
        <ul class="ot-need-list">${list}</ul>
        <div class="ot-confirm-actions">
          <button type="button" class="ot-btn" data-need="close">Kapat</button>
        </div>
      </div>`;
    const close = () => box.remove();
    box.addEventListener('click', (ev) => {
      if (ev.target === box) close();
    });
    box.querySelector('[data-need="close"]').onclick = close;
    document.addEventListener(
      'keydown',
      function onKey(ev) {
        if (ev.key === 'Escape') {
          document.removeEventListener('keydown', onKey);
          close();
        }
      },
      { once: true }
    );
    document.body.appendChild(box);
  }

  function placeLabel(o) {
    const il = String(o.cargoCity || o.province || '').trim();
    const ilce = String(o.cargoTown || o.city || '').trim();
    if (il && ilce && foldSearch(il) !== foldSearch(ilce)) return `${il} · ${ilce}`;
    return il || ilce || '—';
  }

  function cargoCompanyLabel(o) {
    const track = String(o.cargoTracking || '').trim().toUpperCase();
    const raw = String(o.cargoTrackingCompany || '').trim();
    const fold = foldSearch(raw);
    if (/^ADO/i.test(track) || fold.includes('hepsijet') || fold.includes('hepsi jet')) {
      return 'HepsiJet';
    }
    if (/^1Z/i.test(track) || fold.includes('ups')) return 'UPS';
    if (fold.includes('ptt') || /^KP\d/i.test(track)) return 'PTT Kargo';
    if (fold.includes('yurtici') || fold.includes('yurti')) return 'Yurtiçi Kargo';
    if (fold.includes('aras')) return 'Aras Kargo';
    if (fold.includes('mng')) return 'MNG Kargo';
    if (fold.includes('surat')) return 'Sürat Kargo';
    if (fold.includes('trendyol')) return 'Trendyol Express';
    if (o.cargoSource === 'hepsijet') return 'HepsiJet';
    if (raw && fold !== 'kargo' && fold !== 'other' && fold !== 'custom') return raw;
    return '';
  }

  function fmtDuration(ms) {
    if (!Number.isFinite(ms) || ms < 0) ms = 0;
    const totalMin = Math.floor(ms / 60000);
    const d = Math.floor(totalMin / (60 * 24));
    const h = Math.floor((totalMin % (60 * 24)) / 60);
    const m = totalMin % 60;
    if (d > 0) return h > 0 ? `${d} gün ${h} saat` : `${d} gün`;
    if (h > 0) return m > 0 ? `${h} saat ${m} dk` : `${h} saat`;
    return `${Math.max(1, m)} dk`;
  }

  function fmtCargoWhen(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleString('tr-TR', {
        timeZone: 'Europe/Istanbul',
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return '';
    }
  }

  function cargoRows(phase) {
    const now = Date.now();
    const rows = [];
    for (const o of lastData.orders || []) {
      let cargoPhase = String(o.cargoPhase || '');
      let shippedAt = o.shippedAt || '';
      let deliveredAt = o.deliveredAt || '';

      // Firma alma zamanı yoksa süre uydurma — sadece gerçek alma/teslim
      if (!cargoPhase) {
        if (deliveredAt) cargoPhase = 'delivered';
        else if (shippedAt && (o.shopifyShipped || resolveStatus(o) === 'shipped')) {
          cargoPhase = 'in_transit';
        }
      }

      if (phase === 'in_transit') {
        if (cargoPhase !== 'in_transit') continue;
        if (deliveredAt) continue;
        if (!shippedAt) continue;
      } else if (phase === 'delivered') {
        if (!deliveredAt && cargoPhase !== 'delivered') continue;
        if (!deliveredAt) continue;
      } else continue;

      const shipMs = shippedAt ? new Date(shippedAt).getTime() : 0;
      const delMs = deliveredAt ? new Date(deliveredAt).getTime() : 0;
      let durationMs = 0;
      let durationLabel = '';
      const taken = fmtCargoWhen(shippedAt);
      const given = fmtCargoWhen(deliveredAt);
      if (phase === 'in_transit') {
        durationMs = shipMs ? now - shipMs : 0;
        durationLabel = shipMs
          ? `Yolda ${fmtDuration(durationMs)} · alındı ${taken}`
          : 'Alınma saati yok';
      } else {
        durationMs = shipMs && delMs ? delMs - shipMs : 0;
        durationLabel =
          shipMs && delMs
            ? `${fmtDuration(durationMs)} · ${taken} → ${given}`
            : given
              ? `Teslim ${given}`
              : 'Teslim saati yok';
      }

      const company = cargoCompanyLabel(o);
      const desiRaw = Number(o.cargoDesi);
      const desi = Number.isFinite(desiRaw) && desiRaw > 0 ? desiRaw : null;
      rows.push({
        orderName: o.orderName,
        customer: o.customer || '',
        place: placeLabel(o),
        durationLabel,
        durationMs,
        shippedAt,
        deliveredAt,
        tracking: o.cargoTracking || '',
        company,
        desi,
        lastTx: o.cargoLastTx || '',
      });
    }
    rows.sort((a, b) => b.durationMs - a.durationMs);
    return rows;
  }

  function fmtDesi(desi) {
    const n = Number(desi);
    if (!Number.isFinite(n) || n <= 0) return '';
    const text = Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
    return `${text} desi`;
  }

  function openCargoProcess(initialTab) {
    const prev = document.querySelector('.ot-cargo-modal');
    if (prev) prev.remove();
    let tab = initialTab === 'delivered' ? 'delivered' : 'in_transit';
    const box = document.createElement('div');
    box.className = 'ot-confirm ot-cargo-modal';
    const paint = () => {
      const rows = cargoRows(tab);
      const list = rows.length
        ? rows
            .map(
              (r) => `<li>
                <div class="ot-cargo-main">
                  <div class="ot-cargo-title">
                    <strong>${esc(r.orderName)}</strong>
                    ${
                      r.company
                        ? `<span class="ot-cargo-firm">${esc(r.company)}</span>`
                        : ''
                    }
                    ${
                      r.desi != null
                        ? `<span class="ot-cargo-desi" title="Kargo firması geçerli desi">${esc(fmtDesi(r.desi))}</span>`
                        : ''
                    }
                  </div>
                  <span class="ot-cargo-who">${esc(r.customer)}</span>
                </div>
                <div class="ot-cargo-meta">
                  <span class="ot-cargo-place">${esc(r.place)}</span>
                  <span class="ot-cargo-dur">${esc(r.durationLabel)}</span>
                </div>
                ${
                  r.lastTx
                    ? `<div class="ot-cargo-src">${esc(r.lastTx)}</div>`
                    : ''
                }
              </li>`
            )
            .join('')
        : `<li class="ot-need-empty">${
            tab === 'in_transit'
              ? 'Yolda sipariş yok (firma alma saati olanlar)'
              : 'Teslim edilen sipariş yok'
          }</li>`;
      const card = box.querySelector('.ot-cargo-card');
      if (!card) return;
      card.querySelectorAll('[data-cargo-tab]').forEach((btn) => {
        btn.classList.toggle('is-on', btn.getAttribute('data-cargo-tab') === tab);
      });
      const sub = card.querySelector('.ot-confirm-sub');
      if (sub) {
        sub.textContent =
          tab === 'in_transit'
            ? `${rows.length} sipariş · süre = HepsiJet “Gönderi Alındı” saatinden beri`
            : `${rows.length} sipariş · süre = firma alma → teslim edildi`;
      }
      const ul = card.querySelector('.ot-cargo-list');
      if (ul) ul.innerHTML = list;
    };

    box.innerHTML = `
      <div class="ot-confirm-card ot-cargo-card" role="dialog" aria-modal="true">
        <p>Kargo Süreci</p>
        <div class="ot-cargo-tabs">
          <button type="button" class="ot-cargo-tab" data-cargo-tab="in_transit">Yolda</button>
          <button type="button" class="ot-cargo-tab" data-cargo-tab="delivered">Teslim edilen</button>
        </div>
        <p class="ot-confirm-sub"></p>
        <ul class="ot-cargo-list"></ul>
        <div class="ot-confirm-actions">
          <button type="button" class="ot-btn" data-cargo="close">Kapat</button>
        </div>
      </div>`;
    const close = () => box.remove();
    box.addEventListener('click', (ev) => {
      if (ev.target === box) close();
    });
    box.querySelector('[data-cargo="close"]').onclick = close;
    box.querySelectorAll('[data-cargo-tab]').forEach((btn) => {
      btn.onclick = () => {
        tab = btn.getAttribute('data-cargo-tab') || 'in_transit';
        paint();
      };
    });
    document.addEventListener(
      'keydown',
      function onKey(ev) {
        if (ev.key === 'Escape') {
          document.removeEventListener('keydown', onKey);
          close();
        }
      },
      { once: true }
    );
    document.body.appendChild(box);
    paint();
  }

  function playStatusSound() {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    try {
      if (!audioCtx) audioCtx = new AudioCtx();
      if (audioCtx.state === 'suspended') audioCtx.resume().catch(() => {});
      const t = audioCtx.currentTime;
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(740, t);
      osc.frequency.exponentialRampToValueAtTime(1175, t + 0.1);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.2, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.42);
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.start(t);
      osc.stop(t + 0.44);
    } catch {
      /* tarayıcı sesi henüz açmamış olabilir */
    }
  }

  function toastHost() {
    let host = document.getElementById('ot-toasts');
    if (host) return host;
    host = document.createElement('div');
    host.id = 'ot-toasts';
    host.className = 'ot-toasts';
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }

  function showStatusToast(orderName, status, prevStatus) {
    const host = toastHost();
    const card = document.createElement('button');
    card.type = 'button';
    card.className = `ot-toast is-${status || 'wait'}`;
    const order = orderByName(orderName);
    const customer = String(order?.customer || '').trim();
    const product = orderProductLine(orderName);
    const nextLabel = statusLabel(status);
    const prevLabel = prevStatus ? statusLabel(prevStatus) : '';
    const statusLine = prevLabel && prevLabel !== nextLabel ? `${prevLabel} → ${nextLabel}` : nextLabel;
    const who = customer ? `${orderName || 'Sipariş'} · ${customer}` : orderName || 'Sipariş';
    card.innerHTML = `
      <strong>Durum güncellendi</strong>
      <span class="ot-toast-order">Sipariş: ${esc(who)}</span>
      <span class="ot-toast-status">Durum: ${esc(statusLine)}</span>
      ${product ? `<em>Ürün: ${esc(product)}</em>` : ''}
    `;
    card.onclick = () => card.remove();
    host.appendChild(card);
    while (host.children.length > 4) host.firstElementChild.remove();
    setTimeout(() => card.remove(), 8000);
  }

  function noteStatus(key, status) {
    if (!key || String(key).endsWith(VOICE_SUFFIX)) return;
    const next = status || '';
    if (!alertsArmed) {
      seenStatus[key] = next;
      return;
    }
    const prev = Object.prototype.hasOwnProperty.call(seenStatus, key) ? seenStatus[key] : '';
    seenStatus[key] = next;
    if (prev === next) return;
    playStatusSound();
    showStatusToast(key, next, prev);
  }

  function printNote(raw) {
    let text = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    text = text.replace(/kaynak:\s*telegram bot\s*/i, '').trim();
    return text;
  }

  function printStatusStamp(order, compact) {
    const status = resolveStatus(order);
    const label = statusLabel(status);
    const cod = paymentKind(order) === 'cod';
    const voice = isVoiceOk(order.orderName);
    if (compact) {
      const tel = !cod ? '' : voice ? ' · Tel alındı' : ' · Tel yok';
      return `<div class="ot-print-status is-${status || 'wait'}"><strong>${esc(label)}${esc(tel)}</strong></div>`;
    }
    let voiceLine = 'Telefon onayı: gerekmez';
    if (cod) voiceLine = voice ? 'Telefon onayı: ALINDI' : 'Telefon onayı: YOK';
    return `<div class="ot-print-status is-${status || 'wait'}">
      <strong>${esc(label)}</strong>
      <span class="${voice && cod ? 'is-on' : 'is-off'}">${esc(voiceLine)}</span>
    </div>`;
  }

  const openDetails = new Set();
  const openStatuses = new Set();

  function channelMark(o) {
    if (o.source === 'trendyol') return '<span class="ot-channel">Trendyol</span>';
    if (o.source === 'ciceksepeti') return '<span class="ot-channel is-cs">Çiçeksepeti</span>';
    return '';
  }

  function orderNo(name) {
    return Number(String(name || '').replace(/\D/g, '')) || 0;
  }

  function paymentKind(o) {
    if (o.isCod === true) return 'cod';
    if (o.isCod === false) {
      const p = String(o.payment || '').toLocaleLowerCase('tr-TR');
      if (p.includes('havale') || p.includes('eft') || p.includes('banka')) return 'bank';
      return 'card';
    }
    const p = String(o.payment || '').toLocaleLowerCase('tr-TR');
    if (p.includes('kapıda') || p.includes('kapida') || p.includes('cod')) return 'cod';
    if (p.includes('havale') || p.includes('eft') || p.includes('banka')) return 'bank';
    return 'card';
  }

  function financialTone(o) {
    const s = String(o.financial || '').toUpperCase();
    if (s === 'PAID' || s === 'PARTIALLY_PAID') return 'paid';
    if (s === 'PENDING' || s === 'AUTHORIZED') return 'pending';
    if (s === 'REFUNDED' || s === 'PARTIALLY_REFUNDED' || s === 'VOIDED' || s === 'EXPIRED') {
      return 'dead';
    }
    return '';
  }

  function paymentBadge(o) {
    const kind = paymentKind(o);
    const fin = financialTone(o);
    const label = esc(o.payment || (kind === 'cod' ? 'Kapıda ödeme' : 'Kart'));
    const icons = {
      cod: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h18v10H3V7zm2 2v6h14V9H5zm1 1h4v2H6v-2zm9 3c.8 0 1.5.7 1.5 1.5S15.8 17 15 17s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"/></svg>',
      card: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h20v12H2V6zm2 2v2h16V8H4zm0 6v2h6v-2H4z"/></svg>',
      bank: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10h18v2H3v-2zm1 3h2v6H4v-6zm5 0h2v6H9v-6zm5 0h2v6h-2v-6zm5 0h2v6h-2v-6zM2 20h20v2H2v-2zM12 3l10 6H2l10-6z"/></svg>',
    };
    return `<div class="ot-pay is-${kind}${fin ? ` is-${fin}` : ''}">${icons[kind]}<span>${label}</span></div>`;
  }

  function foldSearch(s) {
    return String(s || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c');
  }

  function orderSource(o) {
    return o.source || 'site';
  }

  const SOURCE_LABELS = {
    site: 'Site',
    trendyol: 'Trendyol',
    ciceksepeti: 'Çiçeksepeti',
    hepsiburada: 'Hepsiburada',
    trendyolgo: 'Trendyol Go',
  };

  function sourceFilters(orders) {
    const counts = new Map();
    for (const order of orders || []) {
      const source = orderSource(order);
      counts.set(source, (counts.get(source) || 0) + 1);
    }
    const list = [{ id: '', label: 'Tümü' }];
    for (const [id, label] of Object.entries(SOURCE_LABELS)) {
      if (counts.get(id)) list.push({ id, label, count: counts.get(id) });
    }
    for (const [id, count] of counts) {
      if (!SOURCE_LABELS[id]) list.push({ id, label: id, count });
    }
    return list;
  }

  function orderSearchBits(o) {
    const bits = [
      o.orderName,
      o.customer,
      o.note,
      o.phone,
      o.city,
      o.province,
      o.address,
      o.zip,
      o.payment,
    ];
    for (const item of o.items || []) {
      bits.push(item.title, item.variant, item.sku, item.personalName);
    }
    return bits;
  }

  function orderMatchesSearch(o, q) {
    if (!q) return true;
    const hay = foldSearch(orderSearchBits(o).filter(Boolean).join(' '));
    return q
      .split(/\s+/)
      .filter(Boolean)
      .every((part) => hay.includes(part));
  }

  function paymentFilterLabel(id) {
    if (id === 'cod') return 'Kapıda Ödeme';
    if (id === 'bank') return 'Havale / EFT';
    return 'Tümü';
  }

  function visibleOrders(orders) {
    let list = (orders || []).slice();
    if (filterSource) list = list.filter((o) => orderSource(o) === filterSource);
    if (filterPayment) list = list.filter((o) => paymentKind(o) === filterPayment);
    if (filterStatus === 'shipped') {
      list = list.filter((o) => resolveStatus(o) === 'shipped');
    } else if (filterStatus === 'wait') {
      list = list.filter((o) => resolveStatus(o) === '');
    } else if (filterStatus) {
      list = list.filter((o) => resolveStatus(o) === filterStatus);
    } else {
      list = list.filter((o) => resolveStatus(o) !== 'shipped');
    }
    const q = foldSearch(searchQuery).trim();
    if (q) list = list.filter((o) => orderMatchesSearch(o, q));
    list.sort((a, b) => {
      let cmp = 0;
      if (sortKey === 'time') cmp = new Date(a.createdAt) - new Date(b.createdAt);
      else if (sortKey === 'amount') cmp = Number(a.amount || 0) - Number(b.amount || 0);
      else cmp = orderNo(a.orderName) - orderNo(b.orderName);
      return sortDir === 'asc' ? cmp : -cmp;
    });
    return list;
  }

  function sortMark(key) {
    if (sortKey !== key) return '';
    return sortDir === 'asc' ? ' ↑' : ' ↓';
  }

  function renderGate(err) {
    app.innerHTML = `
      <div class="ot-gate">
        <h1>Order Team</h1>
        <p>Gizli operasyon paneli. Şifre gerekli.</p>
        <div class="ot-err">${err || ''}</div>
        <input id="ot-pass" type="password" placeholder="Şifre" autocomplete="current-password"/>
        <button class="ot-btn ot-btn-primary" id="ot-enter" style="width:100%">Giriş</button>
      </div>`;
    const go = () => {
      const v = document.getElementById('ot-pass').value.trim();
      if (!v) return;
      setPass(v);
      boot();
    };
    document.getElementById('ot-enter').onclick = go;
    document.getElementById('ot-pass').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') go();
    });
  }

  async function fetchOrders(password) {
    const useLocalApi = Boolean(apiBase) && !/^https:/i.test(window.location.protocol);
    if (useLocalApi || (!cfg.feedUrl && !cfg.jsonpUrl)) {
      const headers = {};
      if (password) headers['X-Orderteam-Password'] = password;
      const url = `${apiBase}/api/orders`;
      const res = await fetch(url, { headers, cache: 'no-store' });
      const data = await res.json();
      if (res.status === 401 || data.error === 'password') {
        const err = new Error('password');
        err.code = 'password';
        throw err;
      }
      if (!res.ok || !data.ok) throw new Error(data.error || 'api');
      data.orders = Array.isArray(data.orders) ? data.orders : [];
      return data;
    }

    if (cfg.feedUrl) {
      const u = new URL(cfg.feedUrl, window.location.origin);
      u.searchParams.set('t', String(Date.now()));
      let res;
      try {
        res = await fetch(u.toString(), { cache: 'no-store' });
      } catch {
        res = await fetch(u.toString());
      }
      const text = await res.text();
      const tagged = text.match(/id="orderteam-snapshot"[^>]*>([\s\S]*?)<\/script>/i);
      let raw = tagged ? tagged[1].trim() : '';
      if (!raw) {
        const start = text.lastIndexOf('{"ok"');
        const end = text.lastIndexOf('}');
        raw = start >= 0 && end > start ? text.slice(start, end + 1) : text;
      }
      let data = JSON.parse(raw);
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch {
          /* tek parse yeterli */
        }
      }
      if (!data || (data.ok !== true && !Array.isArray(data.orders))) {
        throw new Error(data?.error || 'feed');
      }
      data.ok = true;
      data.orders = Array.isArray(data.orders) ? data.orders : [];
      return data;
    }

    throw new Error('Veri kaynağı yok');
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function fetchSnapshotAsset() {
    const raw = String(cfg.snapshotUrl || '').trim();
    if (!raw) return null;
    try {
      const u = new URL(raw, window.location.origin);
      u.searchParams.set('t', String(Date.now()));
      const res = await fetch(u.toString(), { cache: 'no-store' });
      if (!res.ok) return null;
      const data = await res.json();
      if (!data || !Array.isArray(data.orders)) return null;
      data.ok = true;
      return data;
    } catch {
      return null;
    }
  }

  async function pokeLiveRefresh() {
    const at = Date.now();
    try {
      await fetchJsonp(statusEndpoint(), {
        action: 'orderteam_status',
        order: '__refresh',
        status: 'refresh',
        at: String(at),
        ...authParams(),
      });
    } catch {
      /* bot 2 sn içinde yakalar; olmazsa normal yayın */
    }
    return at;
  }

  async function fetchFreshOrders(password, clickedAt) {
    const deadline = Date.now() + 22000;
    let last = null;
    while (Date.now() < deadline) {
      const asset = await fetchSnapshotAsset();
      const feed = asset || (await fetchOrders(password).catch(() => null));
      if (feed) {
        last = feed;
        const ts = Date.parse(feed.updatedAt || '');
        if (Number.isFinite(ts) && ts >= clickedAt - 2000) return feed;
      }
      await sleep(1200);
    }
    return last || fetchOrders(password);
  }

  function fetchJsonp(baseUrl, params, timeoutMs = 20000) {
    return new Promise((resolve, reject) => {
      const cb = '_otCb_' + Date.now() + '_' + Math.floor(Math.random() * 999);
      const timer = setTimeout(() => {
        cleanup();
        reject(new Error('timeout'));
      }, timeoutMs);
      function cleanup() {
        clearTimeout(timer);
        delete window[cb];
        if (script.parentNode) script.parentNode.removeChild(script);
      }
      window[cb] = (data) => {
        cleanup();
        resolve(data || {});
      };
      const script = document.createElement('script');
      const u = new URL(baseUrl, window.location.href);
      Object.entries(params || {}).forEach(([k, v]) => {
        if (v != null && v !== '') u.searchParams.set(k, v);
      });
      u.searchParams.set('callback', cb);
      u.searchParams.set('_t', String(Date.now()));
      script.src = u.toString();
      script.onerror = () => {
        cleanup();
        reject(new Error('script'));
      };
      document.head.appendChild(script);
    });
  }

  const statusRetryQueue = new Map();

  function queueStatusRetry(orderName, status, at, phone) {
    statusRetryQueue.set(orderName, { orderName, status, at, phone, tries: 0 });
  }

  async function flushStatusRetries() {
    if (!statusRetryQueue.size) return;
    const jobs = [...statusRetryQueue.values()].slice(0, 4);
    for (const job of jobs) {
      const params = {
        action: 'orderteam_status',
        order: job.orderName,
        status: job.status,
        at: String(job.at),
        phone: job.phone || '',
        ...authParams(),
      };
      let data = null;
      try {
        data = await fetchJsonp(statusEndpoint(), params, 25000);
      } catch {
        data = null;
      }
      if (!data || data.ok === false) {
        try {
          data = await fetchJsonp(googleStatusUrl, params, 25000);
        } catch {
          data = null;
        }
      }
      if (data && data.ok !== false) {
        const want = normalizeTeamStatus(job.status);
        const confirmed = remoteConfirmsStatus(data, job.orderName, want);
        if (data.saved) ingestStatusMap({ [job.orderName]: data.saved });
        else if (confirmed && data.statuses) {
          if (job.orderName in data.statuses) {
            ingestStatusMap({ [job.orderName]: data.statuses[job.orderName] });
          } else if (!want) {
            ingestStatusMap({
              [job.orderName]: { status: CLEAR_STATUS, at: job.at, cleared: true },
            });
          }
        }
        if (data.calls) applyCallMap(data.calls);
        if (confirmed) {
          statusRetryQueue.delete(job.orderName);
          const pend = pendingStatuses[job.orderName];
          if (pend && Number(pend.at || 0) <= Number(job.at || 0)) {
            delete pendingStatuses[job.orderName];
          }
          renderIfChanged();
          continue;
        }
      }
      if (data && data.error === 'password') {
        statusRetryQueue.delete(job.orderName);
        continue;
      }
      job.tries += 1;
      if (job.tries >= 12) statusRetryQueue.delete(job.orderName);
      else statusRetryQueue.set(job.orderName, job);
    }
  }

  function remoteConfirmsStatus(data, orderName, nextStatus) {
    if (!data || data.ok === false) return false;
    if (data.saved) {
      const savedStatus = data.saved.cleared ? '' : normalizeTeamStatus(data.saved.status);
      return savedStatus === nextStatus;
    }
    if (data.statuses && typeof data.statuses === 'object') {
      if (!(orderName in data.statuses)) return !nextStatus;
      return normalizeTeamStatus(data.statuses[orderName]?.status) === nextStatus;
    }
    return false;
  }

  async function persistStatus(orderName, status) {
    const at = Date.now();
    const prevShared = sharedStatuses[orderName];
    const nextStatus = normalizeTeamStatus(status);
    const persistValue = nextStatus || CLEAR_STATUS;
    pendingStatuses[orderName] = { status: nextStatus, at };
    sharedStatuses[orderName] = { status: nextStatus, at };
    const voiceOrder =
      String(orderName || '').endsWith(VOICE_SUFFIX)
        ? String(orderName).slice(0, -VOICE_SUFFIX.length)
        : orderName;
    const hit =
      (lastData.orders || []).find((o) => o.orderName === orderName) ||
      (lastData.orders || []).find((o) => o.orderName === voiceOrder);
    if (hit && !String(orderName || '').endsWith(VOICE_SUFFIX)) {
      hit.teamStatus = nextStatus;
      hit.teamStatusAt = at;
    }
    if (hit && String(orderName || '').endsWith(VOICE_SUFFIX)) {
      hit.voiceOk = nextStatus === VOICE_YES;
    }
    if (statusChannel) {
      try {
        statusChannel.postMessage({ orderName, status: nextStatus, at });
      } catch {
        /* aynı tarayıcı sekmeleri */
      }
    }
    lastStatusSig = '';
    renderTable(lastData);
    noteStatus(orderName, nextStatus);

    if (apiBase) {
      fetch(`${apiBase}/api/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(getPass() ? { 'X-Orderteam-Password': getPass() } : {}),
        },
        body: JSON.stringify({ orderName, status: persistValue, at }),
      }).catch(() => {});
    }

    const phone = hit ? phoneDigits(hit.phone) : '';
    const params = {
      action: 'orderteam_status',
      order: orderName,
      status: persistValue,
      at: String(at),
      phone,
      ...authParams(),
    };
    let data = null;
    try {
      data = await fetchJsonp(statusEndpoint(), params, 25000);
    } catch {
      data = null;
    }
    if (!data || data.ok === false) {
      try {
        data = await fetchJsonp(googleStatusUrl, params, 25000);
      } catch {
        data = null;
      }
    }
    if (data && data.error === 'password') {
      delete pendingStatuses[orderName];
      if (prevShared) sharedStatuses[orderName] = prevShared;
      else delete sharedStatuses[orderName];
      throw new Error('Şifre hatalı');
    }
    if (!data || data.ok === false) {
      queueStatusRetry(orderName, persistValue, at, phone);
      return;
    }

    const confirmed = remoteConfirmsStatus(data, orderName, nextStatus);
    if (data.saved) {
      ingestStatusMap({ [orderName]: data.saved });
    } else if (data.statuses && confirmed) {
      // Sadece bu siparişi işle — tüm haritayı yutma (eski hazır durumu geri getirmesin)
      if (orderName in data.statuses) {
        ingestStatusMap({ [orderName]: data.statuses[orderName] });
      } else if (!nextStatus) {
        ingestStatusMap({ [orderName]: { status: CLEAR_STATUS, at, cleared: true } });
      }
    } else if (data.statuses && !confirmed) {
      queueStatusRetry(orderName, persistValue, at, phone);
      return;
    }

    if (data.calls) applyCallMap(data.calls);
    if (confirmed) {
      statusRetryQueue.delete(orderName);
      const pend = pendingStatuses[orderName];
      if (pend && Number(pend.at || 0) <= at) delete pendingStatuses[orderName];
    } else {
      queueStatusRetry(orderName, persistValue, at, phone);
    }
  }

  function renderIfChanged() {
    const sig = statusSignature();
    if (sig === lastStatusSig) return;
    lastStatusSig = sig;
    renderTable(lastData);
  }

  async function pullSharedStatuses() {
    if (pullBusy) return;
    pullBusy = true;
    const seq = ++pullSeq;
    try {
      let data = null;
      try {
        data = await fetchJsonp(statusEndpoint(), {
          action: 'orderteam_statuses',
          ...authParams(),
        });
      } catch {
        data = null;
      }
      if (seq !== pullSeq) return;
      if (!data || data.ok === false) {
        try {
          data = await fetchJsonp(googleStatusUrl, {
            action: 'orderteam_statuses',
            ...authParams(),
          });
        } catch {
          data = null;
        }
      }
      if (seq !== pullSeq) return;
      if (!data || data.ok === false) return;
      if (data && data.statuses) ingestStatusMap(data.statuses);
      if (data && data.calls) applyCallMap(data.calls);
      if (data && (data.statuses || data.calls)) renderIfChanged();
    } catch {
      /* bir sonraki turda tekrar */
    } finally {
      armAlerts();
      pullBusy = false;
    }
  }

  function setSort(key) {
    if (sortKey === key) sortDir = sortDir === 'asc' ? 'desc' : 'asc';
    else {
      sortKey = key;
      sortDir = key === 'time' ? 'desc' : 'desc';
    }
    renderTable(lastData);
  }

  function bindToolbar() {
    document.querySelectorAll('[data-filter]').forEach((btn) => {
      btn.onclick = () => {
        filterStatus = btn.getAttribute('data-filter') || '';
        renderTable(lastData);
      };
    });
    document.querySelectorAll('[data-source]').forEach((btn) => {
      btn.onclick = () => {
        filterSource = btn.getAttribute('data-source') || '';
        renderTable(lastData);
      };
    });
    document.querySelectorAll('[data-sort]').forEach((btn) => {
      btn.onclick = () => setSort(btn.getAttribute('data-sort'));
    });
    const payDd = document.querySelector('[data-pay-dd]');
    if (payDd) {
      const toggle = payDd.querySelector('[data-pay-toggle]');
      const menu = payDd.querySelector('.ot-pay-dd-menu');
      const closePay = () => {
        if (menu) menu.hidden = true;
        payDd.classList.remove('is-open');
      };
      if (toggle && menu) {
        toggle.onclick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          const open = menu.hidden;
          document.querySelectorAll('[data-pay-dd]').forEach((el) => {
            el.classList.remove('is-open');
            const m = el.querySelector('.ot-pay-dd-menu');
            if (m) m.hidden = true;
          });
          if (open) {
            menu.hidden = false;
            payDd.classList.add('is-open');
          }
        };
      }
      payDd.querySelectorAll('[data-pay]').forEach((btn) => {
        btn.onclick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          filterPayment = btn.getAttribute('data-pay') || '';
          closePay();
          renderToolbar();
          renderTable(lastData);
        };
      });
      if (!bindToolbar._payDocBound) {
        bindToolbar._payDocBound = true;
        document.addEventListener('click', (ev) => {
          if (ev.target?.closest?.('[data-pay-dd]')) return;
          document.querySelectorAll('[data-pay-dd]').forEach((el) => {
            el.classList.remove('is-open');
            const m = el.querySelector('.ot-pay-dd-menu');
            if (m) m.hidden = true;
          });
        });
      }
    }
  }

  function renderShell() {
    app.innerHTML = `
      <div class="ot-wrap">
        <div class="ot-chrome">
          <div class="ot-top">
            <div class="ot-brand">Order Team <span>gönderilmemiş siparişler</span></div>
            <div class="ot-actions">
              <button class="ot-btn ot-btn-ghost" id="ot-products" type="button"><span class="ot-btn-full">Sipariş Ürünler</span><span class="ot-btn-short">Ürünler</span></button>
              <button class="ot-btn ot-btn-ghost" id="ot-cargo" type="button"><span class="ot-btn-full">Kargo süreci</span><span class="ot-btn-short">Kargo</span></button>
              <button class="ot-btn ot-btn-ghost" id="ot-print" type="button"><span class="ot-btn-full">Yazdır</span><span class="ot-btn-short">Yazdır</span></button>
              <button class="ot-btn ot-btn-ghost" id="ot-print-sheet" type="button"><span class="ot-btn-full">Baskı listesi</span><span class="ot-btn-short">Baskı</span></button>
              <button class="ot-btn" id="ot-refresh" type="button"><span class="ot-btn-full ot-idle-lab">Yenile</span><span class="ot-btn-short ot-idle-lab">Yenile</span><span class="ot-busy-lab">Yenileniyor…</span></button>
            </div>
            <div class="ot-daybar" id="ot-daybar" aria-label="Bugünkü özet">
              <span class="ot-day-item"><b id="ot-day-orders">0</b> bugünkü sipariş <small>(00:00–şimdi)</small></span>
              <span class="ot-day-item"><b id="ot-day-pieces">0</b> ürün adedi</span>
              <span class="ot-day-item ot-day-score"><b id="ot-day-score">—</b>/10 kargo puanı</span>
            </div>
            <div class="ot-statbar" id="ot-statbar" aria-label="Sipariş özeti">
              <button type="button" class="ot-stat" data-stat="pending"><b>0</b> bekleyen sipariş</button>
              <button type="button" class="ot-stat" data-stat="in_transit"><b>0</b> yolda sipariş</button>
              <button type="button" class="ot-stat" data-stat="delivered"><b>0</b> teslim edilen sipariş</button>
            </div>
            <div class="ot-statbar ot-teamstatbar" id="ot-teamstatbar" aria-label="Durum özeti">
              <button type="button" class="ot-stat" data-team-stat="wait"><b>0</b> işlemsiz</button>
              <button type="button" class="ot-stat" data-team-stat="printing"><b>0</b> baskıda</button>
              <button type="button" class="ot-stat" data-team-stat="print"><b>0</b> baskı tamam</button>
              <button type="button" class="ot-stat" data-team-stat="ready"><b>0</b> hazır</button>
              <button type="button" class="ot-stat" data-team-stat="packed"><b>0</b> paketlendi</button>
            </div>
          </div>
          <div class="ot-search">
            <span class="ot-search-ico" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M10.5 3a7.5 7.5 0 015.9 12.1l4.2 4.2-1.4 1.4-4.2-4.2A7.5 7.5 0 1110.5 3zm0 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11z"/></svg>
            </span>
            <input id="ot-search" type="search" autocomplete="off" spellcheck="false" placeholder="İsim, soyisim, not, ürün ara…"/>
            <button type="button" class="ot-search-clear" id="ot-search-clear" hidden aria-label="Aramayı sıfırla">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12 19 17.6 17.6 19 12 13.4 6.4 19 5 17.6 10.6 12 5 6.4z"/></svg>
            </button>
          </div>
          <div class="ot-toolbar" id="ot-toolbar"></div>
        </div>
        <div class="ot-meta" id="ot-meta">Yükleniyor…</div>
        <div class="ot-table-wrap" id="ot-body"><div class="ot-loading">Siparişler getiriliyor…</div></div>
        <div id="ot-sheet" class="ot-sheet" hidden></div>
      </div>`;
    document.getElementById('ot-refresh').onclick = () => load(true, { manual: true });
    document.getElementById('ot-products').onclick = () => openProductNeeds();
    document.getElementById('ot-cargo').onclick = () => openCargoProcess('in_transit');
    document.getElementById('ot-print').onclick = () => printSelected('full');
    document.getElementById('ot-print-sheet').onclick = () => printSelected('sheet');
    document.getElementById('ot-statbar')?.querySelectorAll('[data-stat]').forEach((btn) => {
      btn.onclick = () => {
        const kind = btn.getAttribute('data-stat');
        if (kind === 'in_transit') openCargoProcess('in_transit');
        else if (kind === 'delivered') openCargoProcess('delivered');
        else openPendingSummary();
      };
    });
    document.getElementById('ot-teamstatbar')?.querySelectorAll('[data-team-stat]').forEach((btn) => {
      btn.onclick = () => {
        const kind = btn.getAttribute('data-team-stat') || '';
        filterStatus = filterStatus === kind ? '' : kind;
        renderToolbar();
        bindToolbar();
        renderTable(lastData);
      };
    });
    setInterval(() => {
      if (!lastData?.orders) return;
      sweepExpiredPrinting();
      renderDayBar(lastData.orders || []);
    }, 60000);
    const searchEl = document.getElementById('ot-search');
    const clearEl = document.getElementById('ot-search-clear');
    const syncSearchClear = () => {
      if (clearEl) clearEl.hidden = !String(searchQuery || '').trim();
    };
    if (searchEl) {
      searchEl.value = searchQuery;
      searchEl.oninput = () => {
        searchQuery = searchEl.value || '';
        syncSearchClear();
        renderTable(lastData);
      };
    }
    if (clearEl) {
      clearEl.onclick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        searchQuery = '';
        if (searchEl) {
          searchEl.value = '';
          searchEl.focus();
        }
        syncSearchClear();
        renderTable(lastData);
      };
    }
    syncSearchClear();
  }

  function renderToolbar() {
    const bar = document.getElementById('ot-toolbar');
    if (!bar) return;
    const filters = FILTERS.map((f) => {
      const on = filterStatus === f.id ? ' is-on' : '';
      const extra =
        f.id === 'shipped'
          ? ' is-shipped-chip'
          : f.id === 'wait'
            ? ' is-wait-chip'
            : f.id === 'printing'
              ? ' is-printing-chip'
              : f.id === 'ready'
                ? ' is-ready-chip'
                : '';
      const short =
        f.id === ''
          ? 'Tümü'
          : f.id === 'wait'
            ? 'İşlemsiz'
            : f.id === 'printing'
              ? 'Baskıda'
              : f.id === 'print'
                ? 'Tamam'
                : f.id === 'ready'
                  ? 'Hazır'
                  : f.id === 'packed'
                    ? 'Paket'
                    : 'Gitti';
      return `<button type="button" class="ot-chip${extra}${on}" data-filter="${f.id}"><span class="ot-chip-full">${f.label}</span><span class="ot-chip-short">${short}</span></button>`;
    }).join('');
    const sources = sourceFilters(lastData.orders || [])
      .map((source) => {
        const on = filterSource === source.id ? ' is-on' : '';
        const tone = source.id ? ` is-src-${source.id}` : '';
        return `<button type="button" class="ot-chip${tone}${on}" data-source="${esc(source.id)}"><span class="ot-chip-full">${esc(source.label)}</span><span class="ot-chip-short">${esc(source.label)}</span></button>`;
      })
      .join('');
    const payLabel = paymentFilterLabel(filterPayment);
    const payOn = filterPayment ? ' is-on' : '';
    const payTone =
      filterPayment === 'cod' ? ' is-pay-cod' : filterPayment === 'bank' ? ' is-pay-bank' : '';
    bar.innerHTML = `
      <div class="ot-tool-group ot-tool-sources">
        <span class="ot-tool-label">Pazar</span>
        <div class="ot-chips">${sources}</div>
      </div>
      <div class="ot-tool-group ot-tool-filters">
        <span class="ot-tool-label">Filtre</span>
        <div class="ot-chips">${filters}</div>
      </div>
      <div class="ot-tool-group ot-tool-sort">
        <span class="ot-tool-label">Sırala</span>
        <div class="ot-chips">
          <button type="button" class="ot-chip${sortKey === 'time' ? ' is-on' : ''}" data-sort="time"><span class="ot-chip-full">Sipariş zamanı${sortMark('time')}</span><span class="ot-chip-short">Zaman${sortMark('time')}</span></button>
          <button type="button" class="ot-chip${sortKey === 'amount' ? ' is-on' : ''}" data-sort="amount"><span class="ot-chip-full">Sipariş tutarı${sortMark('amount')}</span><span class="ot-chip-short">Tutar${sortMark('amount')}</span></button>
        </div>
      </div>
      <div class="ot-tool-group ot-tool-pay">
        <span class="ot-tool-label">Ödeme Yöntemi</span>
        <div class="ot-pay-dd" data-pay-dd>
          <button type="button" class="ot-chip ot-pay-dd-btn${payOn}${payTone}" data-pay-toggle aria-haspopup="listbox" aria-expanded="false">
            <span class="ot-chip-full">${esc(payLabel)}</span>
            <span class="ot-chip-short">${esc(filterPayment === 'cod' ? 'Kapıda' : filterPayment === 'bank' ? 'Havale' : 'Ödeme')}</span>
            <svg class="ot-pay-dd-caret" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10l5 5 5-5z"/></svg>
          </button>
          <div class="ot-pay-dd-menu" role="listbox" hidden>
            <button type="button" class="ot-pay-dd-item${!filterPayment ? ' is-on' : ''}" data-pay="" role="option">Tümü</button>
            <button type="button" class="ot-pay-dd-item${filterPayment === 'cod' ? ' is-on' : ''}" data-pay="cod" role="option">Kapıda Ödeme</button>
            <button type="button" class="ot-pay-dd-item${filterPayment === 'bank' ? ' is-on' : ''}" data-pay="bank" role="option">Havale / EFT</button>
          </div>
        </div>
      </div>`;
    bindToolbar();
  }

  function pickedOrders() {
    const cards = [...document.querySelectorAll('.ot-card')];
    const pickedNames = cards
      .filter((c) => c.querySelector('.ot-pick')?.checked)
      .map((c) => c.getAttribute('data-order-row'));
    const visible = visibleOrders(lastData.orders || []);
    if (!pickedNames.length) return visible;
    return visible.filter((o) => pickedNames.includes(o.orderName));
  }

  function buildSheetHtml(orders) {
    const when = lastData.updatedAt ? fmtDate(lastData.updatedAt) : '';
    const cards = orders
      .map((o) => {
        const items = (o.items || [])
          .map((it) => {
            const img = it.imageUrl ? `<img src="${esc(it.imageUrl)}" alt=""/>` : '';
            const bits = [`${it.quantity || 1} adet`];
            if (it.variant) bits.push(it.variant);
            if (it.personalName) bits.push(it.personalName);
            return `<div class="ot-line">
              <div class="ot-thumb">${img}<span class="ot-qty">${esc(String(it.quantity || 1))}</span></div>
              <div class="ot-item-title">${esc(it.title || '')} · ${esc(bits.join(' · '))}</div>
            </div>`;
          })
          .join('');
        const note = printNote(o.note);
        return `<article class="ot-sheet-card is-src-${orderSource(o)}">
          <div class="ot-sheet-items">${items || '<div class="ot-note-empty">Ürün yok</div>'}</div>
          <div class="ot-sheet-who">
            <div class="ot-orderno">${esc(o.orderName)}${channelMark(o)}</div>
            <div class="ot-name">${esc(o.customer || '—')}</div>
          </div>
          <div class="ot-sheet-sum">
            <div class="ot-total">${money(o.amount, o.currency)}</div>
            ${paymentBadge(o)}
            ${printStatusStamp(o, true)}
          </div>
          ${note ? `<div class="ot-sheet-note">${esc(note)}</div>` : ''}
        </article>`;
      })
      .join('');
    return `<div class="ot-sheet-head">
        <span>Baskı listesi</span>
        <span>${orders.length} sipariş${when ? ' · ' + when : ''}</span>
      </div>
      <div class="ot-sheet-cols">
        <span>Ürün</span>
        <span>Ad soyad</span>
        <span>Tutar</span>
      </div>
      <div class="ot-sheet-list">${cards}</div>`;
  }

  function printSelected(mode) {
    const cards = [...document.querySelectorAll('.ot-card')];
    const picked = cards.filter((c) => c.querySelector('.ot-pick')?.checked);
    document.body.classList.toggle('ot-print-sel', picked.length > 0 && mode === 'full');
    cards.forEach((c) => c.classList.toggle('is-picked', picked.includes(c)));
    document.body.classList.toggle('ot-print-sheet', mode === 'sheet');
    const sheet = document.getElementById('ot-sheet');
    if (sheet && mode === 'sheet') {
      sheet.hidden = false;
      sheet.innerHTML = buildSheetHtml(pickedOrders());
    }
    const done = () => {
      document.body.classList.remove('ot-print-sel', 'ot-print-sheet');
      cards.forEach((c) => c.classList.remove('is-picked'));
      if (sheet) {
        sheet.hidden = true;
        sheet.innerHTML = '';
      }
      window.removeEventListener('afterprint', done);
    };
    window.addEventListener('afterprint', done);
    window.print();
  }

  function locationLine(o) {
    const province = String(o.province || '').trim();
    const city = String(o.city || '').trim();
    if (province && city && province !== city) return `${province} / ${city}`;
    return province || city || '';
  }

  function voiceButton(order) {
    if (paymentKind(order) !== 'cod') return '';
    const on = isVoiceOk(order.orderName);
    const label = on ? 'Sesli onay alındı' : 'Sesli onay alınmadı';
    return `<button type="button" class="ot-voice ${on ? 'is-on' : 'is-off'}" data-voice="${esc(order.orderName)}">${phoneIcon()}<span>${label}</span></button>`;
  }

  function whatsappBadge(order) {
    const href = waMeHref(order.phone);
    if (!href) return '';
    return `<a class="ot-m-wa" href="${esc(href)}" target="_blank" rel="noopener noreferrer" title="WhatsApp">${phoneIcon()}</a>`;
  }

  function cameraIcon() {
    return '<svg class="ot-phone-ic" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 4l1.2 2h3.6L15 4h4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h4zm3 5.2A3.8 3.8 0 1015.8 13 3.8 3.8 0 0012 9.2z"/></svg>';
  }

  function contactButtons(order) {
    return `<div class="ot-contact">${whatsappBadge(order)}<button type="button" class="ot-m-cam" data-cam="${esc(order.orderName)}" title="Görsel ekle">${cameraIcon()}</button></div>`;
  }

  const MOBILE_PHOTO_API = 'https://retrieval-laboratory-strongly-funk.trycloudflare.com';
  let livePhotoApi = '';

  function rememberPhotoApi(url) {
    const next = String(url || '').trim().replace(/\/$/, '');
    if (/^https:\/\//i.test(next)) livePhotoApi = next;
  }

  function statusEndpoint() {
    if (
      location.port === '8787' ||
      location.hostname === '127.0.0.1' ||
      location.hostname === 'localhost'
    ) {
      return '/api/status';
    }
    return googleStatusUrl;
  }

  function photoBase() {
    if (
      location.port === '8787' ||
      location.hostname === '127.0.0.1' ||
      location.hostname === 'localhost'
    ) {
      return '';
    }
    if (apiBase && !/^https:/i.test(location.protocol)) return apiBase.replace(/\/$/, '');
    return (livePhotoApi || String(cfg.photoApi || MOBILE_PHOTO_API)).replace(/\/$/, '');
  }

  function compressImage(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        const max = 1600;
        let w = img.width || 1;
        let h = img.height || 1;
        const scale = Math.min(1, max / Math.max(w, h));
        w = Math.max(1, Math.round(w * scale));
        h = Math.max(1, Math.round(h * scale));
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(url);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('Görsel hazırlanamadı'));
              return;
            }
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || '').split(',')[1] || '');
            reader.onerror = () => reject(new Error('Görsel okunamadı'));
            reader.readAsDataURL(blob);
          },
          'image/jpeg',
          0.72
        );
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Görsel açılamadı'));
      };
      img.src = url;
    });
  }

  async function postPhoto(path, body) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 90000);
    try {
      const res = await fetch(`${photoBase()}${path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(getPass() ? { 'X-Orderteam-Password': getPass() } : {}),
        },
        body: JSON.stringify(body),
        signal: ctrl.signal,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.ok === false) throw new Error(data.error || 'İşlem olmadı');
      return data;
    } catch (err) {
      if (err && err.name === 'AbortError') throw new Error('Bağlantı zaman aşımı');
      throw err;
    } finally {
      clearTimeout(timer);
    }
  }

  const photoJobs = new Map();
  const pendingPhotoIds = new Set();
  const PHOTO_DB = 'ot-photo-queue';
  const PHOTO_SW_VERSION = '20261005c';
  let photoWorker = null;
  let photoWake = null;
  const photoChannel =
    typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('ot-photo-bg') : null;

  function photoDb() {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open(PHOTO_DB, 1);
      req.onupgradeneeded = () => {
        if (!req.result.objectStoreNames.contains('jobs')) {
          req.result.createObjectStore('jobs', { keyPath: 'id' });
        }
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }

  function idbGet(id) {
    return photoDb().then(
      (db) =>
        new Promise((resolve, reject) => {
          const req = db.transaction('jobs', 'readonly').objectStore('jobs').get(id);
          req.onsuccess = () => resolve(req.result || null);
          req.onerror = () => reject(req.error);
        })
    );
  }

  function idbPut(job) {
    return photoDb().then(
      (db) =>
        new Promise((resolve, reject) => {
          const tx = db.transaction('jobs', 'readwrite');
          tx.objectStore('jobs').put(job);
          tx.oncomplete = () => resolve();
          tx.onerror = () => reject(tx.error);
        })
    );
  }

  function idbDelete(id) {
    return photoDb().then(
      (db) =>
        new Promise((resolve, reject) => {
          const tx = db.transaction('jobs', 'readwrite');
          tx.objectStore('jobs').delete(id);
          tx.oncomplete = () => resolve();
          tx.onerror = () => reject(tx.error);
        })
    );
  }

  function idbAll() {
    return photoDb().then(
      (db) =>
        new Promise((resolve, reject) => {
          const req = db.transaction('jobs', 'readonly').objectStore('jobs').getAll();
          req.onsuccess = () => resolve(req.result || []);
          req.onerror = () => reject(req.error);
        })
    );
  }

  function photoWorkerTarget() {
    const current = [...document.scripts].map((script) => script.src).find((src) => /orderteam\.js(\?|$)/.test(src));
    if (!current) return { script: `/orderteam-sw.js?v=${PHOTO_SW_VERSION}`, scope: `${location.origin}/` };
    const script = new URL(`orderteam-sw.js?v=${PHOTO_SW_VERSION}`, current).href;
    const scope = new URL('./', script).href;
    return { script, scope };
  }

  async function warmPhotoWorker() {
    if (!('serviceWorker' in navigator) || !window.isSecureContext) return null;
    try {
      const target = photoWorkerTarget();
      const reg = await navigator.serviceWorker.register(target.script, { scope: target.scope });
      const worker = reg.installing || reg.waiting;
      if (worker && !reg.active) {
        await new Promise((resolve) => {
          if (worker.state === 'activated') {
            resolve();
            return;
          }
          worker.addEventListener('statechange', () => {
            if (worker.state === 'activated' || worker.state === 'redundant') resolve();
          });
        });
      }
      photoWorker = reg.active || navigator.serviceWorker.controller || null;
      return photoWorker;
    } catch {
      photoWorker = null;
      return null;
    }
  }

  async function keepAwake() {
    try {
      if (!navigator.wakeLock) return;
      if (photoWake) return;
      photoWake = await navigator.wakeLock.request('screen');
      photoWake.addEventListener('release', () => {
        photoWake = null;
      });
    } catch {
      photoWake = null;
    }
  }

  function isIos() {
    return (
      /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  function galleryFileName(orderName) {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    const safe = String(orderName || 'siparis').replace(/[^\dA-Za-z]+/g, '');
    return `Shogun-${safe || 'siparis'}-${stamp}.jpg`;
  }

  function downloadFile(file, name) {
    const link = document.createElement('a');
    const url = URL.createObjectURL(file);
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 8000);
  }

  function saveToPhoneGallery(blob, orderName) {
    const name = galleryFileName(orderName);
    const file = new File([blob], name, { type: blob.type || 'image/jpeg' });
    if (isIos() && navigator.canShare && navigator.canShare({ files: [file] })) {
      return navigator.share({ files: [file], title: 'Galeriye kaydet' }).catch((err) => {
        if (err && err.name === 'AbortError') return;
        downloadFile(file, name);
      });
    }
    downloadFile(file, name);
    return Promise.resolve();
  }

  function canvasJpeg(video) {
    const width = video.videoWidth || 1;
    const height = video.videoHeight || 1;
    const scale = Math.min(1, 1600 / Math.max(width, height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL('image/jpeg', 0.92);
    const b64 = dataUrl.split(',')[1] || '';
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: 'image/jpeg' });
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function whatsappNote(err) {
    return /whatsapp|24 saat|kabul etmedi|numara/i.test(String((err && err.message) || ''));
  }

  function isNetworkError(err) {
    const msg = String((err && err.message) || err || '');
    return (
      err instanceof TypeError ||
      /failed to fetch|network|load failed|aborted|timeout|bağlantı|err_connection|502|503|504/i.test(msg)
    );
  }

  async function ensurePhotoLink() {
    const ping = async (base) => {
      const res = await fetch(`${base}/api/photo-health`, {
        cache: 'no-store',
        signal: AbortSignal.timeout(8000),
      });
      return res.ok;
    };
    try {
      if (await ping(photoBase())) return;
    } catch {
      /* adres yenilenecek */
    }
    await refreshPhotoBase();
    try {
      await ping(photoBase());
    } catch {
      /* asıl yükleme denemesi hatayı gösterecek */
    }
  }

  function beatPhotoClaim(job) {
    job.claimedAt = Date.now();
    return idbPut(job).catch(() => {});
  }

  async function refreshPhotoBase() {
    try {
      const data = await fetchOrders(getPass());
      if (data && data.photoApi) rememberPhotoApi(data.photoApi);
    } catch {
      /* canlı adres bir sonraki denemede yine okunur */
    }
  }

  async function claimPageJob(id) {
    const db = await photoDb();
    return new Promise((resolve, reject) => {
      const tx = db.transaction('jobs', 'readwrite');
      const store = tx.objectStore('jobs');
      const req = store.get(id);
      let claimed = false;
      req.onsuccess = () => {
        const job = req.result;
        if (!job || job.status === 'done' || !(job.images || []).length) return;
        const fresh = job.status === 'claimed' && Date.now() - (job.claimedAt || 0) < 120000;
        if (fresh && job.owner && job.owner !== 'page') return;
        job.status = 'claimed';
        job.owner = 'page';
        job.claimedAt = Date.now();
        store.put(job);
        claimed = true;
      };
      tx.oncomplete = () => resolve(claimed ? idbGet(id) : null);
      tx.onerror = () => reject(tx.error);
    });
  }

  async function markPhotoDone(job, text) {
    const next = {
      ...job,
      images: [],
      status: 'done',
      owner: '',
      kind: 'ok',
      text,
      finishedAt: Date.now(),
    };
    await idbPut(next);
    setPhotoJob(job.orderName, 'ok', text, job.id);
    clearPhotoJobLater(job.orderName, job.id);
    pendingPhotoIds.delete(job.id);
  }

  async function runPhotoJobOnPage(jobId) {
    const job = await claimPageJob(jobId);
    if (!job) return;
    const name = job.orderName;
    const images = job.images || [];
    job.saved = job.saved || {};
    job.base = photoBase();
    const beat = setInterval(() => {
      void beatPhotoClaim(job);
    }, 8000);
    try {
      await ensurePhotoLink();
      job.base = photoBase();
      let count = 0;
      for (let i = 0; i < images.length; i += 1) {
        if (job.saved[String(i)]) {
          count += 1;
          continue;
        }
        setPhotoJob(name, 'busy', `${i + 1}/${images.length} görsel siparişe ekleniyor…`, job.id);
        await beatPhotoClaim(job);
        const saved = await postPhoto('/api/order-photos', {
          orderName: name,
          images: [images[i]],
          clientJobId: `${job.id}:${i}`,
        });
        if (!saved.uploadId) throw new Error('Görsel siparişe yazılamadı');
        job.saved[String(i)] = saved.uploadId;
        count += 1;
        job.savedCount = count;
        job.tries = 0;
        job.claimedAt = Date.now();
        await idbPut(job);
      }
      if (!job.sendToCustomer) {
        await markPhotoDone(job, `${count} görsel siparişe eklendi.`);
        return;
      }
      job.waSent = job.waSent || {};
      let sent = 0;
      for (let i = 0; i < images.length; i += 1) {
        if (job.waSent[String(i)]) {
          sent += 1;
          continue;
        }
        setPhotoJob(name, 'busy', 'Müşteriye WhatsApp’tan gönderiliyor…', job.id);
        await beatPhotoClaim(job);
        const result = await postPhoto('/api/order-photos/send', {
          uploadId: job.saved[String(i)],
          clientJobId: `${job.id}:${i}`,
        });
        if (result.pending) {
          setPhotoJob(name, 'busy', `${sent}/${images.length} gitti, kalan görseller WhatsApp sırasında…`, job.id);
          await beatPhotoClaim(job);
          await sleep(2500);
          i -= 1;
          continue;
        }
        if (result.delivered !== true) throw new Error('WhatsApp sohbetine düşmedi');
        job.waSent[String(i)] = result.messageId || 'sent';
        sent += Number(result.sent) || 1;
        job.claimedAt = Date.now();
        await idbPut(job);
      }
      await markPhotoDone(job, `WhatsApp sohbetine düştü. ${sent} görsel gitti.`);
    } catch (err) {
      if (/WhatsApp’ta yok|WhatsApp'ta yok/.test(String(err && err.message))) {
        await markPhotoDone(job, 'Bu numara WhatsApp’ta yok. Görsel siparişte duruyor.');
        return;
      }
      job.tries = (job.tries || 0) + 1;
      job.status = 'queued';
      job.owner = '';
      job.kind = 'busy';
      job.text = isNetworkError(err)
        ? `Bağlantı koptu, ${job.tries}. deneme sürüyor…`
        : String(err.message || 'Yükleme sürüyor…');
      await refreshPhotoBase();
      job.base = photoBase();
      await idbPut(job).catch(() => {});
      setPhotoJob(name, 'busy', job.text, job.id);
      pendingPhotoIds.add(job.id);
      if (document.hidden) return;
      await sleep(Math.min(20000, 1200 * job.tries));
      const again = await idbGet(job.id);
      if (again && again.status !== 'done' && (again.images || []).length) {
        await runPhotoJobOnPage(job.id);
      }
    } finally {
      clearInterval(beat);
    }
  }

  async function enqueuePhotoJob(order, images, sendToCustomer) {
    const job = {
      id: crypto.randomUUID ? crypto.randomUUID() : `ot-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      orderName: order.orderName,
      images,
      sendToCustomer: !!sendToCustomer,
      password: getPass() || '',
      base: photoBase(),
      status: 'queued',
      owner: '',
      claimedAt: 0,
      tries: 0,
      kind: 'busy',
      text: `${images.length} görsel siparişe ekleniyor…`,
      at: Date.now(),
    };
    pendingPhotoIds.add(job.id);
    setPhotoJob(job.orderName, 'busy', job.text, job.id);
    try {
      await idbPut(job);
    } catch {
      /* depolama yoksa sayfa içinden yükle */
    }
    await runPhotoJobOnPage(job.id);
  }

  async function paintStoredPhotoJobs() {
    let jobs = [];
    try {
      jobs = await idbAll();
    } catch {
      return;
    }
    const now = Date.now();
    for (const job of jobs) {
      if (!job || !job.orderName) continue;
      if ((job.status === 'error' || job.status === 'done') && !(job.images || []).length && job.status === 'error') {
        await idbDelete(job.id).catch(() => {});
        continue;
      }
      if (job.status === 'done') {
        if (job.text) {
          const shown = photoJobs.get(job.orderName);
          if (!shown || shown.text !== job.text) setPhotoJob(job.orderName, 'ok', job.text, job.id);
          clearPhotoJobLater(job.orderName, job.id);
        }
        if (now - (job.finishedAt || job.at || 0) > 8000) await idbDelete(job.id).catch(() => {});
        pendingPhotoIds.delete(job.id);
        continue;
      }
      if (job.text) {
        const shown = photoJobs.get(job.orderName);
        if (!shown || shown.text !== job.text) setPhotoJob(job.orderName, job.kind || 'busy', job.text, job.id);
      }
      pendingPhotoIds.add(job.id);
      const hasImages = (job.images || []).length > 0;
      const stale = job.status === 'claimed' && now - (job.claimedAt || 0) > 120000;
      const waiting = job.status === 'queued' || job.status === 'error' || stale;
      if (hasImages && waiting) {
        const base = photoBase();
        if (base && job.base !== base) {
          job.base = base;
          await idbPut(job).catch(() => {});
        }
        if (document.hidden && photoWorker) photoWorker.postMessage({ type: 'ot-photo-run', jobId: job.id });
        else void runPhotoJobOnPage(job.id);
      }
    }
  }

  function bindPhotoBackground() {
    if (photoChannel) {
      photoChannel.onmessage = (ev) => {
        const msg = ev && ev.data;
        if (!msg || !msg.orderName) return;
        setPhotoJob(msg.orderName, msg.kind || 'busy', msg.text || '', msg.jobId);
        if (msg.kind === 'ok') clearPhotoJobLater(msg.orderName, msg.jobId);
        if (msg.kind === 'ok') pendingPhotoIds.delete(msg.jobId);
      };
    }
    void warmPhotoWorker().then(() => paintStoredPhotoJobs());
    setInterval(() => {
      if (pendingPhotoIds.size) void paintStoredPhotoJobs();
    }, 1500);
    window.addEventListener('pagehide', () => {
      photoWorker?.postMessage({ type: 'ot-photo-run-all' });
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        photoWorker?.postMessage({ type: 'ot-photo-run-all' });
        return;
      }
      if (pendingPhotoIds.size) void keepAwake();
      void paintStoredPhotoJobs();
    });
  }

  function paintPhotoJob(orderName) {
    const job = photoJobs.get(orderName);
    document.querySelectorAll('[data-order-row]').forEach((card) => {
      if (card.getAttribute('data-order-row') !== orderName) return;
      let bar = card.querySelector(':scope > .ot-photo-job');
      if (!job) {
        if (bar) bar.remove();
        return;
      }
      if (!bar) {
        bar = document.createElement('div');
        card.insertBefore(bar, card.firstChild);
      }
      bar.className = `ot-photo-job is-${job.kind}`;
      bar.textContent = job.text;
    });
  }

  function setPhotoJob(orderName, kind, text, token) {
    if (!kind) photoJobs.delete(orderName);
    else photoJobs.set(orderName, { kind, text, token });
    paintPhotoJob(orderName);
  }

  function photoJobHtml(orderName) {
    const job = photoJobs.get(orderName);
    if (!job) return '';
    return `<div class="ot-photo-job is-${job.kind}">${esc(job.text)}</div>`;
  }

  function clearPhotoJobLater(orderName, token) {
    setTimeout(() => {
      const cur = photoJobs.get(orderName);
      if (cur && cur.token === token && cur.kind === 'ok') setPhotoJob(orderName, '', '');
    }, 4500);
  }

  function openPhotoDialog(order) {
    const prev = document.querySelector('.ot-photo');
    if (prev) prev.remove();
    const picked = [];
    let liveStream = null;
    const box = document.createElement('div');
    box.className = 'ot-confirm ot-photo';
    box.innerHTML = `
      <div class="ot-confirm-card" role="dialog" aria-modal="true">
        <p>${esc(order.orderName)} görselleri</p>
        <p class="ot-confirm-sub">Kameradan çekince fotoğraf galeriye de iner. Yükleme ekrandan çıksan da sürer.</p>
        <div class="ot-photo-actions">
          <button type="button" class="ot-btn" data-photo="camera">Kamera</button>
          <label class="ot-btn ot-btn-ghost ot-photo-pick">Galeri
            <input class="ot-photo-file" type="file" accept="image/*" multiple/>
          </label>
        </div>
        <div class="ot-cam-live" hidden>
          <video playsinline autoplay muted></video>
          <div class="ot-cam-live-actions">
            <button type="button" class="ot-btn" data-photo="shutter">Çek</button>
            <button type="button" class="ot-btn ot-btn-ghost" data-photo="cam-close">Kapat</button>
          </div>
        </div>
        <label class="ot-btn ot-photo-pick" data-photo="camera-fallback" hidden>Kameradan seç
          <input class="ot-photo-file" type="file" accept="image/*" capture="environment"/>
        </label>
        <div class="ot-photo-grid"></div>
        <p class="ot-photo-msg"></p>
        <div class="ot-confirm-actions">
          <button type="button" class="ot-btn ot-btn-ghost" data-photo="close">Vazgeç</button>
          <button type="button" class="ot-btn" data-photo="upload" disabled>Yükle</button>
        </div>
      </div>`;
    const grid = box.querySelector('.ot-photo-grid');
    const msg = box.querySelector('.ot-photo-msg');
    const uploadBtn = box.querySelector('[data-photo="upload"]');
    const paint = () => {
      uploadBtn.disabled = !picked.length;
      grid.innerHTML = picked
        .map(
          (item, index) =>
            `<button type="button" class="ot-photo-thumb" data-photo-remove="${index}"><img src="${item.preview}" alt=""/><span>×</span></button>`
        )
        .join('');
    };
    const addFiles = async (files) => {
      msg.textContent = '';
      for (const file of files) {
        if (picked.length >= 8) break;
        const kind = String(file.type || '');
        if (kind && !kind.startsWith('image/')) continue;
        try {
          const data = await compressImage(file);
          if (!data) continue;
          picked.push({ data, preview: `data:image/jpeg;base64,${data}` });
        } catch (err) {
          msg.textContent = err.message || 'Görsel eklenemedi';
        }
      }
      paint();
    };
    const stopLive = () => {
      if (liveStream) {
        liveStream.getTracks().forEach((track) => track.stop());
        liveStream = null;
      }
      const live = box.querySelector('.ot-cam-live');
      if (live) live.hidden = true;
    };
    box.querySelectorAll('.ot-photo-file').forEach((input) => {
      input.onchange = () => {
        const files = [...input.files];
        input.value = '';
        const camera = input.hasAttribute('capture');
        if (camera) {
          for (const file of files) void saveToPhoneGallery(file, order.orderName);
        }
        void addFiles(files).then(() => {
          if (camera && msg && !msg.textContent) msg.textContent = 'Fotoğraf galeriye de kaydedildi.';
        });
      };
    });
    box.querySelector('[data-photo="camera"]').onclick = async () => {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        const fallback = box.querySelector('[data-photo="camera-fallback"]');
        if (fallback) fallback.hidden = false;
        msg.textContent = 'Bu telefonda kamerayı alttaki Kameradan seç ile aç.';
        return;
      }
      try {
        stopLive();
        liveStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: 'environment' }, width: { ideal: 1600 } },
          audio: false,
        });
        const live = box.querySelector('.ot-cam-live');
        const video = live.querySelector('video');
        video.srcObject = liveStream;
        await video.play();
        live.hidden = false;
        msg.textContent = '';
      } catch {
        const fallback = box.querySelector('[data-photo="camera-fallback"]');
        if (fallback) fallback.hidden = false;
        msg.textContent = 'Kamera izni yok. Alttaki Kameradan seç ile çek.';
      }
    };
    box.querySelector('[data-photo="shutter"]').onclick = () => {
      const video = box.querySelector('.ot-cam-live video');
      if (!video || !video.videoWidth) return;
      const blob = canvasJpeg(video);
      void saveToPhoneGallery(blob, order.orderName);
      void addFiles([new File([blob], 'kamera.jpg', { type: 'image/jpeg' })]).then(() => {
        if (msg && !msg.textContent) msg.textContent = 'Fotoğraf galeriye de kaydedildi.';
      });
    };
    box.querySelector('[data-photo="cam-close"]').onclick = () => stopLive();
    grid.onclick = (ev) => {
      const btn = ev.target.closest('[data-photo-remove]');
      if (!btn) return;
      picked.splice(Number(btn.getAttribute('data-photo-remove')), 1);
      paint();
    };
    const closeDialog = () => {
      stopLive();
      box.remove();
    };
    box.querySelector('[data-photo="close"]').onclick = () => closeDialog();
    box.addEventListener('click', (ev) => {
      if (ev.target === box) closeDialog();
    });
    uploadBtn.onclick = async () => {
      if (!picked.length) return;
      uploadBtn.disabled = true;
      const images = picked.map((item) => ({ data: item.data }));
      const sendToCustomer = await askPhotoSend(order);
      closeDialog();
      void keepAwake();
      void enqueuePhotoJob(order, images, sendToCustomer);
    };
    document.body.appendChild(box);
  }

  function askPhotoSend(order) {
    return new Promise((resolve) => {
      const prev = document.querySelector('.ot-photo-ask');
      if (prev) prev.remove();
      const phone = order.phone || 'numara yok';
      const box = document.createElement('div');
      box.className = 'ot-confirm ot-photo-ask';
      box.innerHTML = `
        <div class="ot-confirm-card" role="dialog" aria-modal="true">
          <p>Müşteriye gönderilsin mi?</p>
          <p class="ot-confirm-sub">${esc(order.orderName || '')} · ${esc(String(phone))}</p>
          <div class="ot-confirm-actions">
            <button type="button" class="ot-btn ot-btn-ghost" data-send="no">Hayır</button>
            <button type="button" class="ot-btn" data-send="yes">Evet, WhatsApp'tan gönder</button>
          </div>
        </div>`;
      const finish = (ok) => {
        box.remove();
        resolve(ok);
      };
      box.addEventListener('click', (ev) => {
        if (ev.target === box) finish(false);
      });
      box.querySelector('[data-send="no"]').onclick = () => {
        void keepAwake();
        finish(false);
      };
      box.querySelector('[data-send="yes"]').onclick = () => {
        void keepAwake();
        finish(true);
      };
      document.body.appendChild(box);
    });
  }

  function askShippedConfirm(orderName) {
    return new Promise((resolve) => {
      const prev = document.querySelector('.ot-confirm');
      if (prev) prev.remove();
      const box = document.createElement('div');
      box.className = 'ot-confirm';
      box.innerHTML = `
        <div class="ot-confirm-card" role="dialog" aria-modal="true">
          <p>Bu siparişi <strong>gönderildi</strong> olarak işaretlemek istiyor musun?</p>
          <p class="ot-confirm-sub">${esc(orderName || '')}</p>
          <div class="ot-confirm-actions">
            <button type="button" class="ot-btn ot-btn-ghost" data-confirm="no">Vazgeç</button>
            <button type="button" class="ot-btn" data-confirm="yes">Evet, gönderildi</button>
          </div>
        </div>`;
      const finish = (ok) => {
        box.remove();
        resolve(ok);
      };
      box.addEventListener('click', (ev) => {
        if (ev.target === box) finish(false);
      });
      box.querySelector('[data-confirm="no"]').onclick = () => finish(false);
      box.querySelector('[data-confirm="yes"]').onclick = () => finish(true);
      document.body.appendChild(box);
    });
  }

  function stepButtons(order) {
    const current = resolveStatus(order);
    const locked = current === 'shipped';
    return STEPS.map((step) => {
      const rank = STEP_ORDER[step.id];
      const curRank = STEP_ORDER[current] || 0;
      const cls = [
        'ot-step',
        locked && step.id === 'shipped' ? 'is-shipped is-current' : '',
        !locked && rank < curRank ? 'is-done' : '',
        !locked && step.id === current ? 'is-current' : '',
      ]
        .filter(Boolean)
        .join(' ');
      const disabled = locked ? 'disabled' : '';
      const idx = STEPS.findIndex((s) => s.id === step.id) + 1;
      return `<button type="button" class="${cls}" data-order="${esc(order.orderName)}" data-status="${step.id}" ${disabled}><span>${idx}</span>${step.label}</button>`;
    }).join('');
  }

  function cargoPhaseOf(o) {
    let cargoPhase = String(o.cargoPhase || '');
    const shippedAt = o.shippedAt || '';
    const deliveredAt = o.deliveredAt || '';
    if (!cargoPhase) {
      if (deliveredAt) cargoPhase = 'delivered';
      else if (shippedAt && (o.shopifyShipped || resolveStatus(o) === 'shipped')) {
        cargoPhase = 'in_transit';
      }
    }
    return { cargoPhase, shippedAt, deliveredAt };
  }

  function orderStatCounts(all) {
    let pending = 0;
    let inTransit = 0;
    let delivered = 0;
    const team = { wait: 0, printing: 0, print: 0, ready: 0, packed: 0 };
    for (const o of all || []) {
      const st = resolveStatus(o);
      if (st !== 'shipped') {
        if (!st) team.wait += 1;
        else if (team[st] != null) team[st] += 1;
      }
      const { cargoPhase, shippedAt, deliveredAt } = cargoPhaseOf(o);
      if (deliveredAt || cargoPhase === 'delivered') {
        delivered += 1;
        continue;
      }
      if (cargoPhase === 'in_transit' && shippedAt && !deliveredAt) {
        inTransit += 1;
        continue;
      }
      if (st !== 'shipped') pending += 1;
    }
    return { pending, inTransit, delivered, team };
  }

  function istanbulParts(ms) {
    const d = new Date(ms);
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      })
        .formatToParts(d)
        .filter((p) => p.type !== 'literal')
        .map((p) => [p.type, p.value])
    );
    return {
      y: Number(parts.year),
      m: Number(parts.month),
      d: Number(parts.day),
      h: Number(parts.hour),
      min: Number(parts.minute),
      dayKey: `${parts.year}-${parts.month}-${parts.day}`,
    };
  }

  function istanbulDayBounds(dayKey) {
    // dayKey YYYY-MM-DD → [00:00, next 00:00) Europe/Istanbul as UTC ms
    const [y, m, d] = dayKey.split('-').map(Number);
    const start = Date.parse(
      `${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}T00:00:00+03:00`
    );
    const end = start + 24 * 60 * 60 * 1000;
    return { start, end };
  }

  function trendyolShipDeadlineMs(createdAt) {
    const t = new Date(createdAt).getTime();
    if (!Number.isFinite(t) || t <= 0) return 0;
    const p = istanbulParts(t);
    // 11:00 öncesi → ertesi gün 23:59:59 (Trendyol benzeri)
    if (p.h >= 11) return 0;
    const { start } = istanbulDayBounds(p.dayKey);
    const nextKey = istanbulParts(start + 24 * 60 * 60 * 1000).dayKey;
    return Date.parse(`${nextKey}T23:59:59+03:00`);
  }

  function orderShipMs(o) {
    const a = new Date(o.shippedAt || 0).getTime();
    if (Number.isFinite(a) && a > 0) return a;
    const b = new Date(o.deliveredAt || 0).getTime();
    if (Number.isFinite(b) && b > 0) return b;
    if (o.shopifyShipped || resolveStatus(o) === 'shipped') {
      const u = new Date(o.updatedAt || o.createdAt || 0).getTime();
      if (Number.isFinite(u) && u > 0) return u;
    }
    return 0;
  }

  function todayOpsStats(all) {
    const now = Date.now();
    const todayKey = istanbulParts(now).dayKey;
    const { start } = istanbulDayBounds(todayKey);
    let orders = 0;
    let pieces = 0;
    for (const o of all || []) {
      const t = new Date(o.createdAt || 0).getTime();
      if (!Number.isFinite(t) || t < start || t > now) continue;
      orders += 1;
      for (const it of o.items || []) pieces += Number(it.quantity || 0) || 0;
    }

    // Trendyol benzeri: 11 öncesi sipariş → ertesi 23:59’a kadar kargo
    let eligible = 0;
    let onTime = 0;
    for (const o of all || []) {
      const deadline = trendyolShipDeadlineMs(o.createdAt);
      if (!deadline || deadline > now) continue;
      eligible += 1;
      const ship = orderShipMs(o);
      if (ship > 0 && ship <= deadline) onTime += 1;
    }
    const score =
      eligible > 0 ? Math.round((onTime / eligible) * 100) / 10 : null;
    return { orders, pieces, score, eligible, onTime, todayKey };
  }

  function pendingOrders(all) {
    return (all || []).filter((o) => {
      const { cargoPhase, shippedAt, deliveredAt } = cargoPhaseOf(o);
      if (deliveredAt || cargoPhase === 'delivered') return false;
      if (cargoPhase === 'in_transit' && shippedAt && !deliveredAt) return false;
      return resolveStatus(o) !== 'shipped';
    });
  }

  function openPendingSummary() {
    const prev = document.querySelector('.ot-pending-modal');
    if (prev) prev.remove();
    const rows = pendingOrders(lastData.orders || []);
    const box = document.createElement('div');
    box.className = 'ot-confirm ot-pending-modal';
    const list = rows.length
      ? rows
          .map((o) => {
            const items = (o.items || [])
              .map((it) => {
                const qty = Number(it.quantity || 1) || 1;
                const name = it.personalName ? ` · ${it.personalName}` : '';
                const variant = it.variant ? ` (${it.variant})` : '';
                return `${qty}× ${it.title || 'Ürün'}${variant}${name}`;
              })
              .join(' · ');
            return `<li>
              <div class="ot-cargo-main">
                <strong>${esc(o.orderName)}</strong>
                <span class="ot-cargo-who">${esc(o.customer || '—')}</span>
              </div>
              <div class="ot-cargo-meta">
                <span class="ot-cargo-place">${esc(items || 'Ürün yok')}</span>
                <span class="ot-cargo-dur">${esc(money(o.amount, o.currency))}</span>
              </div>
              <div class="ot-cargo-src">${esc(statusLabel(resolveStatus(o)) || 'İşlemsiz')}${
                o.city || o.province ? ` · ${esc([o.province, o.city].filter(Boolean).join(' / '))}` : ''
              }</div>
            </li>`;
          })
          .join('')
      : '<li class="ot-need-empty">Bekleyen sipariş yok</li>';
    box.innerHTML = `
      <div class="ot-confirm-card ot-cargo-card" role="dialog" aria-modal="true">
        <p>Bekleyen siparişler</p>
        <p class="ot-confirm-sub">${rows.length} sipariş · özet liste</p>
        <ul class="ot-cargo-list">${list}</ul>
        <div class="ot-confirm-actions">
          <button type="button" class="ot-btn" data-pending="close">Kapat</button>
        </div>
      </div>`;
    const close = () => box.remove();
    box.addEventListener('click', (ev) => {
      if (ev.target === box) close();
    });
    box.querySelector('[data-pending="close"]').onclick = close;
    document.addEventListener(
      'keydown',
      function onKey(ev) {
        if (ev.key === 'Escape') {
          close();
          document.removeEventListener('keydown', onKey);
        }
      }
    );
    document.body.appendChild(box);
  }

  function renderStatBar(all) {
    const bar = document.getElementById('ot-statbar');
    const teamBar = document.getElementById('ot-teamstatbar');
    const { pending, inTransit, delivered, team } = orderStatCounts(all);
    if (bar) {
      const map = {
        pending: { n: pending, label: 'bekleyen sipariş' },
        in_transit: { n: inTransit, label: 'yolda sipariş' },
        delivered: { n: delivered, label: 'teslim edilen sipariş' },
      };
      bar.querySelectorAll('[data-stat]').forEach((btn) => {
        const kind = btn.getAttribute('data-stat');
        const row = map[kind];
        if (!row) return;
        btn.innerHTML = `<b>${esc(String(row.n))}</b> ${esc(row.label)}`;
      });
    }
    if (teamBar) {
      const teamMap = {
        wait: { n: team.wait, label: 'işlemsiz' },
        printing: { n: team.printing, label: 'baskıda' },
        print: { n: team.print, label: 'baskı tamam' },
        ready: { n: team.ready, label: 'hazır' },
        packed: { n: team.packed, label: 'paketlendi' },
      };
      teamBar.querySelectorAll('[data-team-stat]').forEach((btn) => {
        const kind = btn.getAttribute('data-team-stat');
        const row = teamMap[kind];
        if (!row) return;
        btn.innerHTML = `<b>${esc(String(row.n))}</b> ${esc(row.label)}`;
        btn.classList.toggle('is-on', filterStatus === kind);
      });
    }
  }

  function renderDayBar(all) {
    const ops = todayOpsStats(all);
    const oEl = document.getElementById('ot-day-orders');
    const pEl = document.getElementById('ot-day-pieces');
    const sEl = document.getElementById('ot-day-score');
    if (oEl) oEl.textContent = String(ops.orders);
    if (pEl) pEl.textContent = String(ops.pieces);
    if (sEl) {
      sEl.textContent = ops.score == null ? '—' : ops.score.toFixed(1).replace(/\.0$/, '');
      sEl.title =
        ops.eligible > 0
          ? `11 öncesi sipariş → ertesi 23:59 kargo · ${ops.onTime}/${ops.eligible} zamanında`
          : 'Henüz puanlanacak (süresi dolmuş) sipariş yok';
      const wrap = sEl.closest('.ot-day-score');
      if (wrap) {
        wrap.classList.toggle('is-good', ops.score != null && ops.score >= 8);
        wrap.classList.toggle('is-mid', ops.score != null && ops.score >= 5 && ops.score < 8);
        wrap.classList.toggle('is-bad', ops.score != null && ops.score < 5);
      }
    }
  }

  function renderTable(data) {
    lastData = data || lastData;
    sweepExpiredPrinting();
    const all = lastData.orders || [];
    const orders = visibleOrders(all);
    const meta = document.getElementById('ot-meta');
    const body = document.getElementById('ot-body');
    const when = lastData.updatedAt ? fmtDate(lastData.updatedAt) : '—';
    const activeCount = all.filter((o) => resolveStatus(o) !== 'shipped').length;
    const shippedCount = all.length - activeCount;
    const qLabel = String(searchQuery || '').trim();
    const searchBit = qLabel ? ` · “${qLabel}”` : '';
    renderDayBar(all);
    renderStatBar(all);
    if (meta) {
      meta.textContent =
        filterStatus === 'shipped'
          ? `Arşiv · ${orders.length} gönderildi${searchBit} · güncelleme ${when}`
          : filterStatus === 'wait'
            ? `${orders.length} işlemsiz${searchBit} · güncelleme ${when}`
            : filterStatus
              ? `${orders.length} / ${activeCount} sipariş${searchBit} · güncelleme ${when}`
              : `${orders.length} açık sipariş · ${shippedCount} arşiv${searchBit} · güncelleme ${when}`;
    }
    renderToolbar();
    if (!body) return;

    if (!orders.length) {
      body.innerHTML = `<div class="ot-empty">${
        !all.length
          ? 'Gönderilmemiş sipariş yok.'
          : qLabel
            ? 'Bu filtrede aramaya uyan sipariş yok.'
            : 'Bu filtrede sipariş yok.'
      }</div>`;
      return;
    }

    const rows = orders
      .map((o) => {
        const status = resolveStatus(o);
        const items = (o.items || [])
          .map((it) => {
            const nameTag = it.personalName
              ? `<div class="ot-name-tag">${esc(it.personalName)}</div>`
              : '';
            const variant = it.variant
              ? `<span class="ot-variant">${esc(it.variant)}</span>`
              : '';
            const img = it.imageUrl ? `<img src="${esc(it.imageUrl)}" alt=""/>` : '';
            const price =
              it.originalPrice && Number(it.originalPrice) > Number(it.unitPrice)
                ? `<div class="ot-price"><s>${money(it.originalPrice, it.currency)}</s>${money(it.unitPrice, it.currency)}</div>`
                : `<div class="ot-price">${money(it.unitPrice, it.currency)}</div>`;
            return `<div class="ot-line">
              <div class="ot-thumb">${img}<span class="ot-qty">${esc(String(it.quantity || 1))}</span></div>
              <div>
                <div class="ot-item-title">${esc(it.title || '')}</div>
                <div class="ot-item-qty">${esc(String(it.quantity || 1))} adet ${variant}</div>
                ${nameTag}
              </div>
              ${price}
            </div>`;
          })
          .join('');

        const loc = locationLine(o);
        const note = String(o.note || '').trim();
        const address = [o.address, loc, o.zip].filter(Boolean).join(' · ');
        const archive = filterStatus === 'shipped';
        const extraCls = [
          status === 'shipped' ? 'is-shipped' : '',
          `is-src-${orderSource(o)}`,
          archive ? 'is-archive' : '',
          openDetails.has(o.orderName) ? 'is-detail-open' : '',
          openStatuses.has(o.orderName) ? 'is-status-open' : '',
        ]
          .filter(Boolean)
          .join(' ');

        return `<article class="ot-card ${extraCls}" data-order-row="${esc(o.orderName)}">
          ${photoJobHtml(o.orderName)}
          <div class="ot-mbar">
            <input class="ot-pick" type="checkbox"/>
            <div class="ot-m-main">
              <button type="button" class="ot-m-name" data-open-detail="${esc(o.orderName)}">
                <span class="ot-orderno">${esc(o.orderName)}${channelMark(o)}</span>
                <span class="ot-name">
                  <span class="ot-name-text">${esc(o.customer || '—')}</span>
                  ${nameMarks(o)}
                  <i class="ot-chev" aria-hidden="true"></i>
                </span>
              </button>
              <div class="ot-m-preview">
                <div class="ot-lines">${items || '<div class="ot-note-empty">Ürün yok</div>'}</div>
                <div class="ot-m-total">${money(o.amount, o.currency)}</div>
              </div>
            </div>
            <div class="ot-m-side">
              <button type="button" class="ot-m-now is-${status || 'wait'}" data-open-status="${esc(o.orderName)}">${esc(statusLabel(status))}</button>
              ${contactButtons(o)}
            </div>
          </div>
          <div class="ot-m-panel ot-m-detail">
            <div class="ot-m-panel-in">
              <dl class="ot-dl">
                <div class="ot-kv"><dt>Telefon</dt><dd><a class="ot-phone" href="tel:${esc(o.phone || '')}">${esc(o.phone || '—')}</a></dd></div>
                <div class="ot-kv"><dt>Adres</dt><dd>${esc(address || loc || '—')}</dd></div>
              </dl>
              ${paymentBadge(o)}
              ${
                note
                  ? `<div class="ot-note-bar"><strong>Not</strong>${esc(note)}</div>`
                  : `<div class="ot-note-empty">Not yok</div>`
              }
            </div>
          </div>
          <div class="ot-m-panel ot-m-statusbox">
            <div class="ot-m-panel-in">
              <div class="ot-kicker">Durum güncelle</div>
              ${voiceButton(o)}
              <div class="ot-steps">${stepButtons(o)}</div>
            </div>
          </div>
          <div class="ot-rail">
            <input class="ot-pick" type="checkbox"/>
            <div class="ot-orderno">${esc(o.orderName)}${channelMark(o)}</div>
          </div>
          <div class="ot-col">
            <div class="ot-kicker">Sipariş bilgileri</div>
            <div class="ot-name"><span class="ot-name-text">${esc(o.customer || '—')}</span>${nameMarks(o)}</div>
            <div class="ot-archive-brief">
              <div class="ot-info-mini">${esc(fmtDate(o.createdAt))}${loc ? ' · ' + esc(loc) : ''}</div>
              <button type="button" class="ot-more-btn" data-toggle="${esc(o.orderName)}">Telefon / adres / not</button>
            </div>
            <dl class="ot-dl ot-archive-hide">
              <div class="ot-kv"><dt>İl / İlçe</dt><dd>${esc(loc || '—')}</dd></div>
              <div class="ot-kv"><dt>Telefon</dt><dd><a class="ot-phone" href="tel:${esc(o.phone || '')}">${esc(o.phone || '—')}</a></dd></div>
              <div class="ot-kv"><dt>Tarih</dt><dd>${esc(fmtDate(o.createdAt))}</dd></div>
            </dl>
            ${archive ? '' : `<div class="ot-remain ${o.overdue ? 'is-late' : ''}">${esc(o.remainingText || '—')}</div>`}
          </div>
          <div class="ot-col">
            <div class="ot-kicker">Sipariş detayı · ${(o.items || []).length} kalem</div>
            <div class="ot-lines">${items || '<div class="ot-note-empty">Ürün yok</div>'}</div>
          </div>
          <div class="ot-col">
            <div class="ot-kicker">Toplam tutar</div>
            <div class="ot-total">${money(o.amount, o.currency)}</div>
            ${paymentBadge(o)}
            <div class="ot-reveal">
              <div class="ot-kv ot-print-hide"><dt>Telefon</dt><dd><a class="ot-phone" href="tel:${esc(o.phone || '')}">${esc(o.phone || '—')}</a></dd></div>
              <div class="ot-kv"><dt>Adres</dt><dd>
                <span class="ot-addr-full">${esc(address || loc || '—')}</span>
                <span class="ot-addr-short">${esc(loc || '—')}</span>
              </dd></div>
              ${
                note
                  ? `<div class="ot-note-bar"><strong>Not</strong><span class="ot-note-text">${esc(note)}</span></div>`
                  : `<div class="ot-note-empty">Not yok</div>`
              }
            </div>
          </div>
          <div class="ot-col ot-col-status">
            <div class="ot-kicker">Durum</div>
            ${contactButtons(o)}
            ${voiceButton(o)}
            <div class="ot-steps">${stepButtons(o)}</div>
            ${printStatusStamp(o)}
          </div>
        </article>`;
      })
      .join('');

    body.innerHTML = `<div class="ot-head">
        <button type="button" class="ot-hbtn" data-sort="no">No${sortMark('no')}</button>
        <button type="button" class="ot-hbtn" data-sort="time">Sipariş bilgileri${sortMark('time')}</button>
        <span>Sipariş detayı</span>
        <button type="button" class="ot-hbtn" data-sort="amount">Tutar / not${sortMark('amount')}</button>
        <span>Durum</span>
      </div>
      <div class="ot-list${filterStatus === 'shipped' ? ' is-archive' : ''}">${rows}</div>`;

    body.querySelectorAll('[data-sort]').forEach((btn) => {
      btn.onclick = () => setSort(btn.getAttribute('data-sort'));
    });
    body.querySelectorAll('[data-order-row]').forEach((row) => {
      const name = row.getAttribute('data-order-row');
      const order = all.find((x) => x.orderName === name);
      if (order) bindRowSteps(row, order, all);
    });
    body.querySelectorAll('[data-open-detail]').forEach((btn) => {
      btn.onclick = () => {
        const id = btn.getAttribute('data-open-detail');
        const card = btn.closest('.ot-card');
        if (!id || !card) return;
        const on = !card.classList.contains('is-detail-open');
        card.classList.toggle('is-detail-open', on);
        if (on) openDetails.add(id);
        else openDetails.delete(id);
      };
    });
    body.querySelectorAll('[data-open-status]').forEach((btn) => {
      btn.onclick = () => {
        const id = btn.getAttribute('data-open-status');
        const card = btn.closest('.ot-card');
        if (!id || !card) return;
        const on = !card.classList.contains('is-status-open');
        card.classList.toggle('is-status-open', on);
        if (on) openStatuses.add(id);
        else openStatuses.delete(id);
      };
    });
  }

  function bindRowSteps(row, order, orders) {
    row.querySelectorAll('[data-voice]').forEach((btn) => {
      btn.onclick = async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const name = btn.getAttribute('data-voice');
        if (!name) return;
        try {
          await persistStatus(voiceKey(name), isVoiceOk(name) ? VOICE_NO : VOICE_YES);
        } catch (err) {
          const meta = document.getElementById('ot-meta');
          if (meta) meta.textContent = err.message || 'Durum kaydedilemedi';
          return;
        }
        lastStatusSig = '';
        renderTable(lastData);
      };
    });
    row.querySelectorAll('.ot-m-wa').forEach((link) => {
      link.onclick = (ev) => ev.stopPropagation();
    });
    row.querySelectorAll('[data-cam]').forEach((btn) => {
      btn.onclick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const name = btn.getAttribute('data-cam');
        const hit = orders.find((item) => item.orderName === name) || order;
        if (hit) openPhotoDialog(hit);
      };
    });
    row.querySelectorAll('.ot-step[data-status]').forEach((btn) => {
      btn.onclick = async () => {
        const orderName = btn.getAttribute('data-order');
        const status = btn.getAttribute('data-status');
        if (!orderName || !status) return;
        const hit = orders.find((x) => x.orderName === orderName) || order;
        const current = resolveStatus(hit || order);
        // Aynı duruma tekrar tıkla → işlemsiz
        const next = current === status ? '' : status;
        if (next === 'shipped') {
          const ok = await askShippedConfirm(orderName);
          if (!ok) return;
        }
        try {
          await persistStatus(orderName, next);
        } catch (err) {
          const meta = document.getElementById('ot-meta');
          if (meta) meta.textContent = err.message || 'Durum kaydedilemedi';
          lastStatusSig = '';
          renderTable(lastData);
          return;
        }
        if (hit) {
          hit.teamStatus = next;
          hit.teamStatusAt = Date.now();
        }
        lastStatusSig = '';
        renderTable(lastData);
        pullSharedStatuses();
      };
    });
  }

  let loadBusy = false;

  async function load(keepShell, opts = {}) {
    const manual = Boolean(opts.manual);
    if (loadBusy && !manual) return;
    loadBusy = true;
    if (!keepShell) renderShell();
    const bodyEl = document.getElementById('ot-body');
    const refreshBtn = document.getElementById('ot-refresh');
    const chrome = document.querySelector('.ot-chrome');
    const meta = document.getElementById('ot-meta');
    if (manual) {
      if (refreshBtn) {
        refreshBtn.classList.add('is-busy');
        refreshBtn.disabled = true;
      }
      chrome?.classList.add('is-refreshing');
      chrome?.classList.remove('is-refreshed');
      if (meta) meta.innerHTML = '<span class="ot-refresh-note">Shopify’dan canlı çekiliyor…</span>';
    }
    try {
      let data;
      if (manual) {
        const clickedAt = await pokeLiveRefresh();
        data = await fetchFreshOrders(getPass(), clickedAt);
      } else {
        data = await fetchOrders(getPass());
      }
      ingestFeedStatuses(data.orders);
      if (data.photoApi) rememberPhotoApi(data.photoApi);
      lastData = data;
      lastStatusSig = statusSignature(data.orders);
      renderTable(data);
      pullSharedStatuses();
      if (manual) {
        chrome?.classList.add('is-refreshed');
        const metaEl = document.getElementById('ot-meta');
        if (metaEl) {
          metaEl.insertAdjacentHTML(
            'afterbegin',
            '<span class="ot-refresh-note is-done">Güncellendi · </span>'
          );
        }
        window.setTimeout(() => chrome?.classList.remove('is-refreshed'), 1800);
      }
    } catch (err) {
      if (err.code === 'password') {
        clearPass();
        renderGate('Şifre hatalı');
        return;
      }
      if (bodyEl) {
        bodyEl.innerHTML = `<div class="ot-empty">Veri alınamadı: ${esc(err.message || err)}</div>`;
      }
    } finally {
      loadBusy = false;
      if (refreshBtn) {
        refreshBtn.classList.remove('is-busy');
        refreshBtn.disabled = false;
      }
      chrome?.classList.remove('is-refreshing');
    }
  }

  function boot() {
    if (cfg.clientGate && cfg.expectedPassword) {
      if (!getPass()) {
        renderGate('');
        return;
      }
      if (getPass() !== String(cfg.expectedPassword)) {
        clearPass();
        renderGate('Şifre hatalı');
        return;
      }
    } else if (passwordRequired && !getPass()) {
      renderGate('');
      return;
    }
    load();
    const poll = Number(cfg.pollMs || 8000);
    const statusPoll = Number(cfg.statusPollMs || 2500);
    if (poll > 0) setInterval(() => load(true), poll);
    if (statusPoll > 0) setInterval(() => pullSharedStatuses(), statusPoll);
    setInterval(() => {
      flushStatusRetries().catch(() => {});
    }, 4000);
    bindPhotoBackground();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        pullSharedStatuses();
        flushStatusRetries().catch(() => {});
      }
    });
    window.addEventListener('focus', () => {
      pullSharedStatuses();
      flushStatusRetries().catch(() => {});
    });
    if (statusChannel) {
      statusChannel.onmessage = (ev) => {
        const msg = ev && ev.data;
        if (!msg || !msg.orderName || !msg.status) return;
        ingestStatusMap({ [msg.orderName]: { status: msg.status, at: msg.at } });
        renderIfChanged();
      };
    }
  }

  boot();
})();
